import { g as jr } from "./_commonjsHelpers-C6fGbg64.js";
const Er = [Number, Boolean, String, Object, Array], _i = (e) => Er.includes(e), Pr = (e, t) => e === Number ? typeof t == "number" : e === Boolean ? typeof t == "boolean" : e === String ? typeof t == "string" : e === Array ? t instanceof Array : typeof t == "object";
class de {
  /**
   * @param {object} config The configuration for the parser
   * @param {string} nullishUniqueType The nullish unique type for this template
   * @param {Function} getUniqueType Function that returns the unique type of this template
   * @param {Function} getUsers Function that returns the users for this template
   * @param {Function} decorateUsersFieldsWithExternalSources decorates users with external sources
   * @param {Function} parserValidator An extra validator to check rules specific for a parser (eg. If A exists then B must exist)
   */
  constructor(t, i, r, s, n, a = () => ({ status: !0 })) {
    if (typeof t != "object")
      throw new Error("1º argument must be an object");
    this.requiredFields = [];
    for (const u in t) {
      const l = t[u];
      if (typeof l != "object")
        throw new Error(`Type of field "${u}" must be a object`);
      if (typeof l.required != "boolean")
        throw new Error(`Invalid required value in "${u}"`);
      if (typeof l.type == "function")
        if (_i(l.type))
          l.type = [l.type];
        else
          throw new Error(`"${l.type.name}" is not a javascript type in field ${u}`);
      else if (l.type instanceof Array) {
        for (const d of l.type)
          if (!_i(d))
            throw new Error(`"${d.name}" is not a javascript type in field ${u}`);
      } else
        throw new Error('Field must have a field "type" of javascript type or a array of javascript types');
      if (l.validator === void 0 && (l.validator = () => ({ status: !0 })), !(l.validator instanceof Function))
        throw new Error(`Field "${u}" validator must be of type function`);
      this.config = t, this.parserValidator = a, this.getUsersFunction = s, n ? this.decorateUsersFieldsWithExternalSourcesFunction = n : this.decorateUsersFieldsWithExternalSourcesFunction = (d, _) => {
        for (const w of d.creators)
          _.has(w.userId) && (w.externalSources = _.get(w.userId));
        return d;
      }, this.getUniqueTypeFunction = r, this.nullishUniqueTypeConst = i, l.isValid = (d, _) => {
        let w = !1;
        for (const T of l.type)
          w = Pr(T, d);
        return w ? l.validator(d, _) : { status: !1, error: "invalid-type" };
      }, l.getBestValue = (d) => l.bestValues(d), l.getCalculatedValue = (d) => l.calculatedValues(d), l.required && this.requiredFields.push(u);
    }
  }
  /**
   * Get userids in the given metadata
   * @param {object} metadata - metadata to get the users from
   * @returns {Array} - Array of userids
   */
  getUsers(t) {
    return this.getUsersFunction(t);
  }
  /**
   * Set users fields with external sources
   * @param {object} metadata Record
   * @param {*} usersMap users map
   * @returns {Array} - Array of fields
   */
  decorateUsersFieldsWithExternalSources(t, i) {
    return this.decorateUsersFieldsWithExternalSourcesFunction(t, i);
  }
  /**
   * Get metadata type
   * @param {object} metadata - Metadata for which the type will extracted
   * @returns {string} - Type for this kind of metadata
   */
  getType(t) {
    return t.type;
  }
  /**
   * Generates a unique type taking into account the Version/Edition fields
   * @param {object} metadata - Metadata for which the unique id will be generated
   * @returns {string} - unique type for this kind of metadata
   */
  getUniqueType(t) {
    return this.getUniqueTypeFunction(t);
  }
  /**
   * Checks whether the unique type generated is nullish (which happens for metadata
   * which does not have or has invalid Version/Edition fields)
   * @param {object} metadata - Metadata for which to check if the unique type identifier is nullish
   * @returns {boolean} - boolean value indicating whether the unique type for the metadata is nullish
   */
  hasNullishUniqueType(t) {
    return this.getUniqueType(t) === this.nullishUniqueType;
  }
  /**
   * Unique type for metadata that does not have or has invalid Version/Edition fields
   */
  get nullishUniqueType() {
    return this.nullishUniqueTypeConst;
  }
  /** Fields available in the parser */
  get fields() {
    return Object.keys(this.config);
  }
  /**
   * Runs the parser to validate the record
   * @param {object} record Record to validate
   * @param {string[]} [ignored] A list of fields to ignore, metadata field is always ignored
   * @returns {object} - Object with the result of the validation
   */
  validate(t, i = []) {
    i = i.concat(["metadata"]);
    const r = {
      status: !0,
      fields: {}
    };
    for (const n in t)
      if (!i.includes(n))
        if (this.config[n] === void 0)
          r.fields[n] = { type: "not-in-schema", error: `${n} not in schema` }, r.status = !1;
        else {
          const a = this.config[n].isValid(t[n]);
          a.status || (r.fields[n] = { type: "invalid-domain", error: a.error }, r.status = !1);
        }
    for (const n in this.config)
      i.includes(n) || this.config[n].required && t[n] === void 0 && (r.fields[n] = { type: "required-in-schema", error: "required-in-schema" }, r.status = !1);
    const s = this.parserValidator(t, i);
    return s.status || (r.status = !1, r.fields = { ...r.fields, ...s.fields }), r;
  }
  /**
   * Validates an individual field
   * @param {string} field The identifier o the field to validate
   * @param {*} fieldValue The value of the field to be tested
   */
  validateByField(t, i) {
    const r = {
      status: !0,
      field: {}
    };
    if (this.config[t] === void 0)
      r.field = { type: "not-in-schema", error: `${t} not in schema` }, r.status = !1;
    else {
      const s = this.config[t].isValid(i);
      s.status || (r.field = { type: "invalid-domain", error: s.error }, r.status = !1);
    }
    return r;
  }
  /**
   * Receives a fieldId and an array of field values and returns the best match for the field
   * @param {string} field The identifier o the field to validate
   * @param {Array} fieldValues An array of possible fieldValues
   * @param {boolean} [ignoreExtraFields] Whether validations of extra fields should be ignored
   */
  getBestValueByFieldFromArray(t, i, r = !1) {
    const s = { status: !0, field: {} };
    if (this.config[t] === void 0)
      return s.field = { type: "not-in-schema", error: `${t} not in schema` }, s.status = !1, s;
    const n = [], a = {};
    for (let d = 0, _ = 0; d < i.length; ++d)
      this.config[t].isValid(i[d], r).status && (n.push(i[d]), a[_] = d, _++);
    if (n.length === 0)
      return { index: -1, value: null };
    const { index: u, value: l } = this.config[t].getBestValue(n);
    return {
      index: a[u],
      value: l
    };
  }
  /**
   * Receives a fieldId and an info object and returns
   * @param {string} field The identifier o the field to validate
   * @param {object} info An object with record, config and extra
   * @returns {any} - Calculated value for the field or null if not able to calculate
   */
  getCalculatedValueByField(t, i) {
    if (this.config[t] === void 0)
      throw new Error(`Error in getCalculatedValue, no field ${t} in schema`);
    return this.config[t].getCalculatedValue(i);
  }
}
const Cr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    advisors: {
      required: !0,
      type: Array,
      validator: e.advisors,
      bestValues: t.advisors,
      calculatedValues: i.advisors
    },
    description: {
      required: !0,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.description
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAccepted: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAccepted
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    tid: {
      required: !1,
      type: String,
      validator: e.tid,
      bestValues: t.tid,
      calculatedValues: i.tid
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "master-thesis" ? { status: !1, error: "type-must-be-master-thesis" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Array,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    degreeName: {
      required: !1,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.email
    },
    institutionName: {
      required: !1,
      type: String,
      validator: e.institutionName,
      bestValues: t.institutionName,
      calculatedValues: i.institutionName
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    }
  },
  "master-thesis",
  // nullish unique type
  function(s) {
    return "master-thesis";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s = []) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Ur = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    advisors: {
      required: !0,
      type: Array,
      validator: e.advisors,
      bestValues: t.advisors,
      calculatedValues: i.advisors
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.description
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAccepted: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAccepted
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    tid: {
      required: !1,
      type: String,
      validator: e.tid,
      bestValues: t.tid,
      calculatedValues: i.tid
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "doctoral-thesis" ? { status: !1, error: "type-must-be-doctoral-thesis" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Array,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    degreeName: {
      required: !1,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.degreeName
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.authorEmail
    },
    institutionName: {
      required: !1,
      type: String,
      validator: e.institutionName,
      bestValues: t.institutionName,
      calculatedValues: i.institutionName
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    }
  },
  "doctoral-thesis",
  // nullish unique type
  function(s) {
    return "doctoral-thesis";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s = []) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Nr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "journal-article" ? { status: !1, error: "type-must-be-journal-article" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    version: {
      required: !1,
      type: String,
      validator: e.version,
      bestValues: t.version,
      calculatedValues: i.version
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    publisher: {
      required: !1,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.description
    },
    publisherVersionUri: {
      required: !1,
      type: String,
      validator: e.publisherVersionUri,
      bestValues: t.publisherVersionUri,
      calculatedValues: i.publisherVersionUri
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    citationTitle: {
      required: !1,
      type: String,
      validator: e.title,
      bestValues: t.citationTitle,
      calculatedValues: i.citationTitle
    },
    citationVolume: {
      required: !1,
      type: String,
      validator: e.citationVolume,
      bestValues: t.citationVolume,
      calculatedValues: i.citationVolume
    },
    citationIssue: {
      required: !1,
      type: String,
      validator: e.citationIssue,
      bestValues: t.citationIssue,
      calculatedValues: i.citationIssue
    },
    citationStartPage: {
      required: !1,
      type: String,
      validator: e.citationStartPage,
      bestValues: t.citationStartPage,
      calculatedValues: i.citationStartPage
    },
    citationEndPage: {
      required: !1,
      type: String,
      validator: e.citationEndPage,
      bestValues: t.citationEndPage,
      calculatedValues: i.citationEndPage
    },
    citationEdition: {
      required: !1,
      type: Number,
      validator: e.citationEdition,
      bestValues: t.citationEdition,
      calculatedValues: i.citationEdition
    },
    issn: {
      required: !1,
      type: String,
      validator: e.issn,
      bestValues: t.issn,
      calculatedValues: i.issn
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.authorEmail
    }
  },
  "journal-article-null",
  // nullish unique type
  function(s) {
    const { status: n } = e.version(s.version);
    return n ? `journal-article-${s.version}` : "journal-article-null";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Fr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "book" ? { status: !1, error: "type-must-be-book" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    peerreviewed: {
      required: !1,
      type: String,
      validator: e.peerreviewed,
      bestValues: t.peerreviewed,
      calculatedValues: i.peerreviewed
    },
    publisher: {
      required: !0,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    publisherVersionUri: {
      required: !1,
      type: String,
      validator: e.publisherVersionUri,
      bestValues: t.publisherVersionUri,
      calculatedValues: i.publisherVersionUri
    },
    citationEdition: {
      required: !1,
      type: Number,
      validator: e.citationEdition,
      bestValues: t.citationEdition,
      calculatedValues: i.citationEdition
    },
    citationVolume: {
      required: !1,
      type: String,
      validator: e.citationVolume,
      bestValues: t.citationVolume,
      calculatedValues: i.citationVolume
    },
    isbn: {
      required: !1,
      type: String,
      validator: e.isbn,
      bestValues: t.isbn,
      calculatedValues: i.isbn
    },
    issn: {
      required: !1,
      type: String,
      validator: e.issn,
      bestValues: t.issn,
      calculatedValues: i.issn
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.abstract
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.email
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    }
  },
  "book-null",
  // nullish unique type
  function(s) {
    const { status: n } = e.citationEdition(s.citationEdition);
    return n ? `book-${s.citationEdition}` : "book-null";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Rr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "book-part" ? { status: !1, error: "type-must-be-book-part" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    peerreviewed: {
      required: !1,
      type: String,
      validator: e.peerreviewed,
      bestValues: t.peerreviewed,
      calculatedValues: i.peerreviewed
    },
    publisher: {
      required: !0,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    publisherVersionUri: {
      required: !1,
      type: String,
      validator: e.publisherVersionUri,
      bestValues: t.publisherVersionUri,
      calculatedValues: i.publisherVersionUri
    },
    citationTitle: {
      required: !1,
      type: String,
      validator: e.title,
      bestValues: t.citationTitle,
      calculatedValues: i.citationTitle
    },
    citationEdition: {
      required: !1,
      type: Number,
      validator: e.citationEdition,
      bestValues: t.citationEdition,
      calculatedValues: i.citationEdition
    },
    citationVolume: {
      required: !1,
      type: String,
      validator: e.citationVolume,
      bestValues: t.citationVolume,
      calculatedValues: i.citationVolume
    },
    citationStartPage: {
      required: !1,
      type: String,
      validator: e.citationStartPage,
      bestValues: t.citationStartPage,
      calculatedValues: i.citationStartPage
    },
    citationEndPage: {
      required: !1,
      type: String,
      validator: e.citationEndPage,
      bestValues: t.citationEndPage,
      calculatedValues: i.citationEndPage
    },
    isbn: {
      required: !1,
      type: String,
      validator: e.isbn,
      bestValues: t.isbn,
      calculatedValues: i.isbn
    },
    issn: {
      required: !1,
      type: String,
      validator: e.issn,
      bestValues: t.issn,
      calculatedValues: i.issn
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.description
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.authorEmail
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    }
  },
  "book-part-null",
  // nullish unique type
  function(s) {
    const { status: n } = e.citationEdition(s.citationEdition);
    return n ? `book-part-${s.citationEdition}` : "book-part-null";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Vr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "conference-object" ? { status: !1, error: "type-must-be-conference-object" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    version: {
      required: !1,
      type: String,
      validator: e.version,
      bestValues: t.version,
      calculatedValues: i.version
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    publisher: {
      required: !1,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.abstract
    },
    publisherVersionUri: {
      required: !1,
      type: String,
      validator: e.publisherVersionUri,
      bestValues: t.publisherVersionUri,
      calculatedValues: i.publisherVersionUri
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    citationTitle: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.citationTitle,
      calculatedValues: i.citationTitle
    },
    citationConferencePlace: {
      required: !1,
      type: String,
      validator: e.citationConferencePlace,
      bestValues: t.citationConferencePlace,
      calculatedValues: i.citationConferencePlace
    },
    citationConferenceDateStart: {
      required: !1,
      type: Object,
      validator: e.fullDate,
      bestValues: t.date,
      calculatedValues: i.citationConferenceDate
    },
    citationConferenceDateEnd: {
      required: !1,
      type: Object,
      validator: e.fullDate,
      bestValues: t.date,
      calculatedValues: i.citationConferenceDate
    },
    citationVolume: {
      required: !1,
      type: String,
      validator: e.citationVolume,
      bestValues: t.citationVolume,
      calculatedValues: i.citationVolume
    },
    citationIssue: {
      required: !1,
      type: String,
      validator: e.citationIssue,
      bestValues: t.citationIssue,
      calculatedValues: i.citationIssue
    },
    citationStartPage: {
      required: !1,
      type: String,
      validator: e.citationStartPage,
      bestValues: t.citationStartPage,
      calculatedValues: i.citationStartPage
    },
    citationEndPage: {
      required: !1,
      type: String,
      validator: e.citationEndPage,
      bestValues: t.citationEndPage,
      calculatedValues: i.citationEndPage
    },
    citationEdition: {
      required: !1,
      type: Number,
      validator: e.citationEdition,
      bestValues: t.citationEdition,
      calculatedValues: i.citationEdition
    },
    isbn: {
      required: !1,
      type: String,
      validator: e.isbn,
      bestValues: t.isbn,
      calculatedValues: i.isbn
    },
    issn: {
      required: !1,
      type: String,
      validator: e.issn,
      bestValues: t.issn,
      calculatedValues: i.issn
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !1,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.authorEmail
    }
  },
  "conference-object-null",
  // nullish unique type
  function(s) {
    const { status: n } = e.version(s.version);
    return n ? `conference-object-${s.version}` : "conference-object-null";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Wr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    advisors: {
      required: !1,
      type: Array,
      validator: e.advisors,
      bestValues: t.advisors,
      calculatedValues: i.advisors
    },
    editors: {
      required: !1,
      type: Array,
      validator: e.editors,
      bestValues: t.editors,
      calculatedValues: i.editors
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAccepted: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAccepted
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    tid: {
      required: !1,
      type: String,
      validator: e.tid,
      bestValues: t.tid,
      calculatedValues: i.tid
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "other" ? { status: !1, error: "type-must-be-other" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !1,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.abstract
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    authorEmail: {
      required: !1,
      type: String,
      validator: e.email,
      bestValues: t.email,
      calculatedValues: i.email
    },
    peerreviewed: {
      required: !1,
      type: String,
      validator: e.peerreviewed,
      bestValues: t.peerreviewed,
      calculatedValues: i.peerreviewed
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    version: {
      required: !1,
      type: String,
      validator: e.version,
      bestValues: t.version,
      calculatedValues: i.version
    },
    publisher: {
      required: !1,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    publisherVersionUri: {
      required: !1,
      type: String,
      validator: e.publisherVersionUri,
      bestValues: t.publisherVersionUri,
      calculatedValues: i.publisherVersionUri
    },
    citationTitle: {
      required: !1,
      type: String,
      validator: e.title,
      bestValues: t.citationTitle,
      calculatedValues: i.citationTitle
    },
    citationVolume: {
      required: !1,
      type: String,
      validator: e.citationVolume,
      bestValues: t.citationVolume,
      calculatedValues: i.citationVolume
    },
    citationIssue: {
      required: !1,
      type: String,
      validator: e.citationIssue,
      bestValues: t.citationIssue,
      calculatedValues: i.citationIssue
    },
    citationStartPage: {
      required: !1,
      type: String,
      validator: e.citationStartPage,
      bestValues: t.citationStartPage,
      calculatedValues: i.citationStartPage
    },
    citationEndPage: {
      required: !1,
      type: String,
      validator: e.citationEndPage,
      bestValues: t.citationEndPage,
      calculatedValues: i.citationEndPage
    },
    citationEdition: {
      required: !1,
      type: Number,
      validator: e.citationEdition,
      bestValues: t.citationEdition,
      calculatedValues: i.citationEdition
    },
    citationConferencePlace: {
      required: !1,
      type: String,
      validator: e.citationConferencePlace,
      bestValues: t.citationConferencePlace,
      calculatedValues: i.citationConferencePlace
    },
    citationConferenceDateStart: {
      required: !1,
      type: Object,
      validator: e.fullDate,
      bestValues: t.citationConferenceDate,
      calculatedValues: i.citationConferenceDate
    },
    citationConferenceDateEnd: {
      required: !1,
      type: Object,
      validator: e.fullDate,
      bestValues: t.citationConferenceDate,
      calculatedValues: i.citationConferenceDate
    },
    isbn: {
      required: !1,
      type: String,
      validator: e.isbn,
      bestValues: t.isbn,
      calculatedValues: i.isbn
    },
    issn: {
      required: !1,
      type: String,
      validator: e.issn,
      bestValues: t.issn,
      calculatedValues: i.issn
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    }
  },
  "other",
  // nullish unique type
  function(s) {
    return "other";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Lr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    dateAccepted: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAccepted
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "report" ? { status: !1, error: "type-must-be-report" } : { status: !0 },
      bestValues: (r) => ({
        index: 0,
        value: r[0]
      }),
      calculatedValues: (r) => null
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    peerreviewed: {
      required: !1,
      type: String,
      validator: e.peerreviewed,
      bestValues: t.peerreviewed,
      calculatedValues: i.peerreviewed
    },
    publisher: {
      required: !1,
      type: String,
      validator: e.publisher,
      bestValues: t.publisher,
      calculatedValues: i.publisher
    },
    description: {
      required: !0,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.abstract
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    subjectFos: {
      required: !1,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    }
  },
  "report",
  // nullish unique type
  function(s) {
    return "report";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), Hr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "patent" ? { status: !1, error: "type-must-be-patent" } : { status: !0 },
      calculatedValues: (r) => null
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !1,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    description: {
      required: !1,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.abstract
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    licenseCondition: {
      required: !1,
      type: String,
      validator: e.licenseCondition,
      bestValues: t.licenseCondition,
      calculatedValues: i.licenseCondition
    },
    embargofct: {
      required: !1,
      type: String,
      validator: e.embargofct,
      bestValues: t.embargofct,
      calculatedValues: i.embargofct
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    }
  },
  "patent",
  // nullish unique type
  function(s) {
    return "patent";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), n;
  }
), zr = (e, t, i) => new de(
  {
    title: {
      required: !0,
      type: String,
      validator: e.title,
      bestValues: t.title,
      calculatedValues: i.title
    },
    titleAlternative: {
      required: !1,
      type: String,
      validator: e.titleAlternative,
      bestValues: t.titleAlternative,
      calculatedValues: i.titleAlternative
    },
    creators: {
      required: !0,
      type: Array,
      validator: e.creators,
      bestValues: t.creators,
      calculatedValues: i.creators
    },
    dateIssued: {
      required: !0,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateIssued
    },
    dateAvailable: {
      required: !1,
      type: Object,
      validator: e.date,
      bestValues: t.date,
      calculatedValues: i.dateAvailable
    },
    type: {
      required: !0,
      type: String,
      validator: (r) => r !== "lecture" ? { status: !1, error: "type-must-be-lecture" } : { status: !0 },
      calculatedValues: (r) => null
    },
    rights: {
      required: !0,
      type: String,
      validator: e.rights,
      bestValues: t.rights,
      calculatedValues: i.rights
    },
    description: {
      required: !0,
      type: String,
      validator: e.abstract,
      bestValues: t.abstract,
      calculatedValues: i.description
    },
    doi: {
      required: !1,
      type: String,
      validator: e.doi,
      bestValues: t.doi,
      calculatedValues: i.doi
    },
    govdoc: {
      required: !1,
      type: String,
      validator: e.govdoc,
      bestValues: t.govdoc,
      calculatedValues: i.govdoc
    },
    pmid: {
      required: !1,
      type: Number,
      validator: e.pmid,
      bestValues: t.pmid,
      calculatedValues: i.pmid
    },
    wos: {
      required: !1,
      type: String,
      validator: e.wos,
      bestValues: t.wos,
      calculatedValues: i.wos
    },
    identifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    relatedIdentifierUri: {
      required: !1,
      type: String,
      validator: e.identifierUri,
      bestValues: t.identifierUri,
      calculatedValues: i.identifierUri
    },
    relatedIdentifierType: {
      required: !1,
      type: String,
      validator: e.relatedIdentifierType,
      bestValues: t.relatedIdentifierType,
      calculatedValues: i.relatedIdentifierType
    },
    subject: {
      required: !1,
      type: Array,
      validator: e.subject,
      bestValues: t.subject,
      calculatedValues: i.subject
    },
    subjectFos: {
      required: !0,
      type: String,
      validator: e.subjectFos,
      bestValues: t.subjectFos,
      calculatedValues: i.subjectFos
    },
    language: {
      required: !0,
      type: String,
      validator: e.language,
      bestValues: t.language,
      calculatedValues: i.language
    },
    fundingReferences: {
      required: !1,
      type: Object,
      validator: e.fundingReferences,
      bestValues: t.fundingReferences,
      calculatedValues: i.fundingReferences
    },
    files: {
      required: !1,
      type: Array,
      validator: e.files,
      bestValues: t.files,
      calculatedValues: i.files
    }
  },
  "lecture-null",
  // nullish unique type
  function(s) {
    return "lecture";
  },
  function(s) {
    var n;
    return ((n = s.creators) == null ? void 0 : n.filter((a) => a.userId).map((a) => a.userId)) ?? [];
  },
  null,
  function(r, s) {
    const n = { status: !0, fields: {} };
    return r.rights === "embargoed-access" && ["dateAvailable"].filter((u) => !s.includes(u)).forEach((u) => {
      u in r || (n.status = !1, n.fields[u] = { type: "required-if-rights-embargoed", error: "required-if-rights-embargoed" });
    }), r.relatedIdentifierUri && !s.includes("relatedIdentifierType") && ("relatedIdentifierType" in r || (n.status = !1, n.fields.relatedIdentifierType = { type: "required-if-related-identifier-uri", error: "required-if-related-identifier-uri" })), n;
  }
);
var ft = { exports: {} }, Br = ft.exports, vi;
function Ii() {
  return vi || (vi = 1, (function(e, t) {
    (function(i, r) {
      e.exports = r();
    })(Br, (function() {
      var i = 1e3, r = 6e4, s = 36e5, n = "millisecond", a = "second", u = "minute", l = "hour", d = "day", _ = "week", w = "month", T = "quarter", U = "year", ee = "date", he = "Invalid Date", ue = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, He = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, W = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, B = function(p, m, c) {
        var b = String(p);
        return !b || b.length >= m ? p : "" + Array(m + 1 - b.length).join(c) + p;
      }, te = { s: B, z: function(p) {
        var m = -p.utcOffset(), c = Math.abs(m), b = Math.floor(c / 60), g = c % 60;
        return (m <= 0 ? "+" : "-") + B(b, 2, "0") + ":" + B(g, 2, "0");
      }, m: function p(m, c) {
        if (m.date() < c.date()) return -p(c, m);
        var b = 12 * (c.year() - m.year()) + (c.month() - m.month()), g = m.clone().add(b, w), k = c - g < 0, S = m.clone().add(b + (k ? -1 : 1), w);
        return +(-(b + (c - g) / (k ? g - S : S - g)) || 0);
      }, a: function(p) {
        return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
      }, p: function(p) {
        return { M: w, y: U, w: _, d, D: ee, h: l, m: u, s: a, ms: n, Q: T }[p] || String(p || "").toLowerCase().replace(/s$/, "");
      }, u: function(p) {
        return p === void 0;
      } }, ie = "en", Ye = {};
      Ye[ie] = W;
      var $t = function(p) {
        return p instanceof ut;
      }, at = function(p, m, c) {
        var b;
        if (!p) return ie;
        if (typeof p == "string") Ye[p] && (b = p), m && (Ye[p] = m, b = p);
        else {
          var g = p.name;
          Ye[g] = p, b = g;
        }
        return !c && b && (ie = b), b || !c && ie;
      }, F = function(p, m) {
        if ($t(p)) return p.clone();
        var c = typeof m == "object" ? m : {};
        return c.date = p, c.args = arguments, new ut(c);
      }, Y = te;
      Y.l = at, Y.i = $t, Y.w = function(p, m) {
        return F(p, { locale: m.$L, utc: m.$u, x: m.$x, $offset: m.$offset });
      };
      var ut = (function() {
        function p(c) {
          this.$L = at(c.locale, null, !0), this.parse(c);
        }
        var m = p.prototype;
        return m.parse = function(c) {
          this.$d = (function(b) {
            var g = b.date, k = b.utc;
            if (g === null) return /* @__PURE__ */ new Date(NaN);
            if (Y.u(g)) return /* @__PURE__ */ new Date();
            if (g instanceof Date) return new Date(g);
            if (typeof g == "string" && !/Z$/i.test(g)) {
              var S = g.match(ue);
              if (S) {
                var I = S[2] - 1 || 0, C = (S[7] || "0").substring(0, 3);
                return k ? new Date(Date.UTC(S[1], I, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, C)) : new Date(S[1], I, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, C);
              }
            }
            return new Date(g);
          })(c), this.$x = c.x || {}, this.init();
        }, m.init = function() {
          var c = this.$d;
          this.$y = c.getFullYear(), this.$M = c.getMonth(), this.$D = c.getDate(), this.$W = c.getDay(), this.$H = c.getHours(), this.$m = c.getMinutes(), this.$s = c.getSeconds(), this.$ms = c.getMilliseconds();
        }, m.$utils = function() {
          return Y;
        }, m.isValid = function() {
          return this.$d.toString() !== he;
        }, m.isSame = function(c, b) {
          var g = F(c);
          return this.startOf(b) <= g && g <= this.endOf(b);
        }, m.isAfter = function(c, b) {
          return F(c) < this.startOf(b);
        }, m.isBefore = function(c, b) {
          return this.endOf(b) < F(c);
        }, m.$g = function(c, b, g) {
          return Y.u(c) ? this[b] : this.set(g, c);
        }, m.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
          return this.$d.getTime();
        }, m.startOf = function(c, b) {
          var g = this, k = !!Y.u(b) || b, S = Y.p(c), I = function(Ee, L) {
            var Oe = Y.w(g.$u ? Date.UTC(g.$y, L, Ee) : new Date(g.$y, L, Ee), g);
            return k ? Oe : Oe.endOf(d);
          }, C = function(Ee, L) {
            return Y.w(g.toDate()[Ee].apply(g.toDate("s"), (k ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(L)), g);
          }, E = this.$W, R = this.$M, De = this.$D, ge = "set" + (this.$u ? "UTC" : "");
          switch (S) {
            case U:
              return k ? I(1, 0) : I(31, 11);
            case w:
              return k ? I(1, R) : I(0, R + 1);
            case _:
              var ze = this.$locale().weekStart || 0, Be = (E < ze ? E + 7 : E) - ze;
              return I(k ? De - Be : De + (6 - Be), R);
            case d:
            case ee:
              return C(ge + "Hours", 0);
            case l:
              return C(ge + "Minutes", 1);
            case u:
              return C(ge + "Seconds", 2);
            case a:
              return C(ge + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m.endOf = function(c) {
          return this.startOf(c, !1);
        }, m.$set = function(c, b) {
          var g, k = Y.p(c), S = "set" + (this.$u ? "UTC" : ""), I = (g = {}, g[d] = S + "Date", g[ee] = S + "Date", g[w] = S + "Month", g[U] = S + "FullYear", g[l] = S + "Hours", g[u] = S + "Minutes", g[a] = S + "Seconds", g[n] = S + "Milliseconds", g)[k], C = k === d ? this.$D + (b - this.$W) : b;
          if (k === w || k === U) {
            var E = this.clone().set(ee, 1);
            E.$d[I](C), E.init(), this.$d = E.set(ee, Math.min(this.$D, E.daysInMonth())).$d;
          } else I && this.$d[I](C);
          return this.init(), this;
        }, m.set = function(c, b) {
          return this.clone().$set(c, b);
        }, m.get = function(c) {
          return this[Y.p(c)]();
        }, m.add = function(c, b) {
          var g, k = this;
          c = Number(c);
          var S = Y.p(b), I = function(R) {
            var De = F(k);
            return Y.w(De.date(De.date() + Math.round(R * c)), k);
          };
          if (S === w) return this.set(w, this.$M + c);
          if (S === U) return this.set(U, this.$y + c);
          if (S === d) return I(1);
          if (S === _) return I(7);
          var C = (g = {}, g[u] = r, g[l] = s, g[a] = i, g)[S] || 1, E = this.$d.getTime() + c * C;
          return Y.w(E, this);
        }, m.subtract = function(c, b) {
          return this.add(-1 * c, b);
        }, m.format = function(c) {
          var b = this, g = this.$locale();
          if (!this.isValid()) return g.invalidDate || he;
          var k = c || "YYYY-MM-DDTHH:mm:ssZ", S = Y.z(this), I = this.$H, C = this.$m, E = this.$M, R = g.weekdays, De = g.months, ge = function(L, Oe, jt, lt) {
            return L && (L[Oe] || L(b, k)) || jt[Oe].substr(0, lt);
          }, ze = function(L) {
            return Y.s(I % 12 || 12, L, "0");
          }, Be = g.meridiem || function(L, Oe, jt) {
            var lt = L < 12 ? "AM" : "PM";
            return jt ? lt.toLowerCase() : lt;
          }, Ee = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: E + 1, MM: Y.s(E + 1, 2, "0"), MMM: ge(g.monthsShort, E, De, 3), MMMM: ge(De, E), D: this.$D, DD: Y.s(this.$D, 2, "0"), d: String(this.$W), dd: ge(g.weekdaysMin, this.$W, R, 2), ddd: ge(g.weekdaysShort, this.$W, R, 3), dddd: R[this.$W], H: String(I), HH: Y.s(I, 2, "0"), h: ze(1), hh: ze(2), a: Be(I, C, !0), A: Be(I, C, !1), m: String(C), mm: Y.s(C, 2, "0"), s: String(this.$s), ss: Y.s(this.$s, 2, "0"), SSS: Y.s(this.$ms, 3, "0"), Z: S };
          return k.replace(He, (function(L, Oe) {
            return Oe || Ee[L] || S.replace(":", "");
          }));
        }, m.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(c, b, g) {
          var k, S = Y.p(b), I = F(c), C = (I.utcOffset() - this.utcOffset()) * r, E = this - I, R = Y.m(this, I);
          return R = (k = {}, k[U] = R / 12, k[w] = R, k[T] = R / 3, k[_] = (E - C) / 6048e5, k[d] = (E - C) / 864e5, k[l] = E / s, k[u] = E / r, k[a] = E / i, k)[S] || E, g ? R : Y.a(R);
        }, m.daysInMonth = function() {
          return this.endOf(w).$D;
        }, m.$locale = function() {
          return Ye[this.$L];
        }, m.locale = function(c, b) {
          if (!c) return this.$L;
          var g = this.clone(), k = at(c, b, !0);
          return k && (g.$L = k), g;
        }, m.clone = function() {
          return Y.w(this.$d, this);
        }, m.toDate = function() {
          return new Date(this.valueOf());
        }, m.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
          return this.$d.toISOString();
        }, m.toString = function() {
          return this.$d.toUTCString();
        }, p;
      })(), bi = ut.prototype;
      return F.prototype = bi, [["$ms", n], ["$s", a], ["$m", u], ["$H", l], ["$W", d], ["$M", w], ["$y", U], ["$D", ee]].forEach((function(p) {
        bi[p[1]] = function(m) {
          return this.$g(m, p[0], p[1]);
        };
      })), F.extend = function(p, m) {
        return p.$i || (p(m, ut, F), p.$i = !0), F;
      }, F.locale = at, F.isDayjs = $t, F.unix = function(p) {
        return F(1e3 * p);
      }, F.en = Ye[ie], F.Ls = Ye, F.p = {}, F;
    }));
  })(ft)), ft.exports;
}
var Zr = Ii();
const Ze = /* @__PURE__ */ jr(Zr), Jr = [
  "journal-article",
  "book",
  "master-thesis",
  "doctoral-thesis",
  "book-part",
  "conference-object",
  "report",
  "lecture",
  "patent",
  "other"
], Qr = {
  empty: { en: "Empty", pt: "Vazio" },
  mathematics: { en: "Mathematics", pt: "Matemática" },
  "computer-and-information-sciences": {
    en: "Computer and information sciences",
    pt: "Ciências da Computação e da Informação"
  },
  "physical-sciences": { en: "Physical sciences", pt: "Física" },
  "chemical-sciences": { en: "Chemical sciences", pt: "Química" },
  "earth-and-related-environmental-sciences": {
    en: "Earth and related environmental sciences",
    pt: "Ciências da Terra e Ciências do Ambiente"
  },
  "biological-sciences": {
    en: "Biological sciences",
    pt: "Ciências Biológicas"
  },
  "other-natural-sciences": {
    en: "Other natural sciences",
    pt: "Outras Ciências Naturais"
  },
  "civil-engineering": { en: "Civil engineering", pt: "Engenharia Civil" },
  "electrical-engineering-electronic-engineering-information-engineering": {
    en: "Electrical engineering, electronic engineering, information engineering",
    pt: "Engenharia Eletrotécnica, Eletrónica e Informática"
  },
  "mechanical-engineering": {
    en: "Mechanical engineering",
    pt: "Engenharia Mecânica"
  },
  "chemical-engineering": {
    en: "Chemical engineering",
    pt: "Engenharia Química"
  },
  "materials-engineering": {
    en: "Materials engineering",
    pt: "Engenharia dos Materiais"
  },
  "medical-engineering": { en: "Medical engineering", pt: "Engenharia Médica" },
  "environmental-engineering": {
    en: "Environmental engineering",
    pt: "Engenharia do Ambiente"
  },
  "environmental-biotechnology": {
    en: "Environmental biotechnology",
    pt: "Biotecnologia Ambiental"
  },
  "industrial-biotechnology": {
    en: "Industrial Biotechnology",
    pt: "Biotecnologia Industrial"
  },
  "nano-technology": { en: "Nano-technology", pt: "Nanotecnologia" },
  "other-engineering-and-technologies": {
    en: "Other engineering and technologies",
    pt: "Outras Ciências da Engenharia e Tecnologias"
  },
  "basic-medicine": { en: "Basic medicine", pt: "Medicina Básica" },
  "clinical-medicine": { en: "Clinical medicine", pt: "Medicina Clínica" },
  "health-sciences": { en: "Health sciences", pt: "Ciências de Saúde" },
  "health-biotechnology": {
    en: "Medical biotechnology",
    pt: "Biotecnologia Médica"
  },
  "other-medical-sciences": {
    en: "Other medical sciences",
    pt: "Outras ciências médicas"
  },
  "agriculture-forestry-and-fisheries": {
    en: "Agriculture, forestry, and fisheries",
    pt: "Agricultura, Silvicultura, e Pescarias"
  },
  "animal-and-dairy-science": {
    en: "Animal and dairy science",
    pt: "Ciência Animal e dos Laticínios"
  },
  "veterinary-science": {
    en: "Veterinary science",
    pt: "Ciências Veterinárias"
  },
  "agricultural-biotechnology": {
    en: "Agricultural biotechnology",
    pt: "Biotecnologia Agrária e Alimentar"
  },
  "other-agricultural-sciences": {
    en: "Other agricultural sciences",
    pt: "Outras Ciências Agrárias"
  },
  psychology: { en: "Psychology", pt: "Psicologia" },
  "economics-and-business": {
    en: "Economics and business",
    pt: "Economia e Gestão"
  },
  "educational-sciences": {
    en: "Educational sciences",
    pt: "Ciências da Educação"
  },
  sociology: { en: "Sociology", pt: "Sociologia" },
  law: { en: "Law", pt: "Direito" },
  "political-science": { en: "Political Science", pt: "Ciências Políticas" },
  "social-and-economic-geography": {
    en: "Social and economic geography",
    pt: "Geografia Económica e Social"
  },
  "media-and-communications": {
    en: "Media and communications",
    pt: "Ciências da Comunicação"
  },
  "other-social-sciences": {
    en: "Other social sciences",
    pt: "Outras ciências sociais"
  },
  "history-and-archaeology": {
    en: "History and archaeology",
    pt: "História e Arqueologia"
  },
  "languages-and-literature": {
    en: "Languages and literature",
    pt: "Línguas e Literaturas"
  },
  "philosophy-ethics-and-religion": {
    en: "Philosophy, ethics and religion",
    pt: "Filosofia, Ética e Religião"
  },
  "arts-history-of-arts-performing-arts-music": {
    en: "Art (arts, history of arts, performing arts, music)",
    pt: "Artes"
  },
  "other-humanities": { en: "Other humanities", pt: "Outras Humanidades" }
}, Ai = Object.keys(Qr), $i = ["AM", "P", "VoR", "CVoR", "EVoR"], ji = ["AO", "SMUR", "NA"], Xr = [...$i, ...ji], Kr = ["yes", "no"], Gr = [
  "CC-BY",
  "CC-BY-SA",
  "CC-BY-ND",
  "CC-BY-NC",
  "CC-BY-NC-SA",
  "CC-BY-NC-ND"
], es = [
  "open-access",
  "embargoed-access",
  "restricted-access",
  "metadata-only-access"
], Ei = [
  "por",
  "eng",
  "cmn",
  "ita",
  "deu",
  "mwl",
  "spa",
  "fra"
], ts = ["fulltext", "dataset", "software", "other"], is = ["ISNI", "GRID", "Crossref Funder"], rs = [
  "IsCitedBy",
  "Cites",
  "IsSupplementTo",
  "IsSupplementedBy",
  "IsContinuedBy",
  "Continues",
  "IsDescribedBy",
  "Describes",
  "HasMetadata",
  "IsMetadataFor",
  "HasVersion",
  "IsVersionOf",
  "IsNewVersionOf",
  "IsPreviousVersionOf",
  "IsPartOf",
  "HasPart",
  "IsReferencedBy",
  "References",
  "IsDocumentedBy",
  "Documents",
  "IsCompiledBy",
  "Compiles",
  "IsVariantFormOf",
  "IsOriginalFormOf",
  "IsIdenticalTo",
  "IsReviewedBy",
  "Reviews",
  "IsDerivedFrom",
  "IsSourceOf",
  "IsRequiredBy",
  "Requires"
], we = {
  fileType: ts,
  language: Ei,
  peerreviewed: Kr,
  rights: es,
  licenseCondition: Gr,
  subjectFos: Ai,
  template: Jr,
  version: Xr,
  funderIdentifierTypes: is,
  relatedIdentifierType: rs
}, Pi = (e, t) => Object.keys(t).filter((i) => !e.includes(i)), Bt = ({ requiredUserId: e, val: t, ignoreExtraFields: i }) => {
  let r = 0;
  if (t.length <= 0)
    return { status: !1, error: "array-must-have-one-element" };
  for (const s of t) {
    if (!(s instanceof Object))
      return { status: !1, error: "elements-of-array-must-be-objects" };
    if (!i && Pi(["name", "userId"], s).length > 0)
      return { status: !1, error: "extra-keys-not-allowed" };
    if (typeof s.name != "string")
      return { status: !1, error: "required-name-field-has-string" };
    const n = t.filter((a) => a.userId).map((a) => a.userId);
    if (n.length !== new Set(n).size)
      return { status: !1, error: "a-user-can-only-be-associated-with-one-signature" };
    if (s.userId) {
      if (typeof s.userId != "string")
        return { status: !1, error: "userId-field-has-string" };
      r += 1;
    }
  }
  return e && r === 0 ? { status: !1, error: "at-least-one-userid" } : { status: !0 };
};
function Ci(e) {
  return we.rights.includes(e) ? { status: !0 } : { status: !1, error: "rights-wrong-access" };
}
function Ui(e) {
  if (!e || typeof e != "object" || e instanceof Array)
    return { status: !1, error: "funding-reference-must-be-object" };
  if (e.funderName) {
    if (typeof e.funderName != "string")
      return { status: !1, error: "funder-name-must-be-of-type-string" };
  } else return { status: !1, error: "funder-name-must-be-defined" };
  return e.funderIdentifier && typeof e.funderIdentifier != "string" ? { status: !1, error: "funder-identifier-must-be-of-type-string" } : e.funderIdentifierType && !we.funderIdentifierTypes.includes(e.funderIdentifierType) ? { status: !1, error: "funder-identifier-is-invalid" } : e.fundingStream && typeof e.fundingStream != "string" ? { status: !1, error: "funder-stream-must-be-of-type-string" } : e.awardNumber && typeof e.awardNumber != "string" ? { status: !1, error: "award-number-must-be-of-type-string" } : e.awardTitle && typeof e.awardTitle != "string" ? { status: !1, error: "award-title-must-be-of-type-string" } : { status: !0 };
}
function ss(e) {
  return e.length < 3 ? { status: !1, error: "min-length-3" } : e.length > 1e3 ? { status: !1, error: "max-length-1000" } : typeof e != "string" ? { status: !1, error: "title-has-string" } : { status: !0 };
}
function ns(e) {
  return e.length < 3 ? { status: !1, error: "min-length-3" } : e.length > 1e3 ? { status: !1, error: "max-length-1000" } : { status: !0 };
}
function as(e) {
  const t = Ni(e);
  return t.status ? Object.keys(e).length !== 3 ? { status: !1, error: "date-must-be-complete" } : { status: !0 } : t;
}
function Ni(e) {
  if (Pi(["year", "month", "day"], e).length > 0)
    return { status: !1, error: "extra-keys-not-allowed" };
  if (!("year" in e))
    return { status: !1, error: "year-must-exist" };
  if (!Number.isInteger(e.year))
    return { status: !1, error: "year-must-be-integer" };
  if (!("month" in e) && "day" in e)
    return { status: !1, error: "month-must-exists-if-day-exists" };
  if ("month" in e) {
    if (!Number.isInteger(e.month))
      return { status: !1, error: "month-must-be-integer" };
    if (e.month < 1 || e.month > 12)
      return { status: !1, error: "month-between-1-and-12" };
    if ("day" in e) {
      if (!Number.isInteger(e.day))
        return { status: !1, error: "day-must-be-integer" };
      if ([1, 3, 5, 7, 8, 10, 12].includes(e.month)) {
        if (e.day < 1 || e.day > 31)
          return { status: !1, error: "day-between-1-and-31" };
      } else if (e.month !== 2) {
        if (e.day < 1 || e.day > 30)
          return { status: !1, error: "day-between-1-and-30" };
      } else if (e.year % 400 === 0 || e.year % 100 !== 0 && e.year % 4 === 0) {
        if (e.day < 1 || e.day > 29)
          return { status: !1, error: "day-between-1-and-29" };
      } else if (e.day < 1 || e.day > 28)
        return { status: !1, error: "day-between-1-and-28" };
    }
  }
  return { status: !0 };
}
function us(e) {
  return /^[0-9]{9}$/.test(e) ? { status: !0 } : { status: !1, error: "tid-must-be-9-number" };
}
function ls(e) {
  return e.length > 100 ? { status: !1, error: "max-length-100" } : { status: !0 };
}
function os(e) {
  return we.subjectFos.includes(e) ? { status: !0 } : { status: !1, error: "subject-fos-wrong-option" };
}
function ds(e) {
  return e.length < 3 ? { status: !1, error: "min-length-3" } : typeof e != "string" ? { status: !1, error: "abstract-has-string" } : e.length > 1e7 ? { status: !1, error: "max-length-10000000" } : { status: !0 };
}
function fs(e) {
  if (!(e instanceof Array))
    return { status: !1, error: "subject-must-be-array" };
  for (const t of e)
    if (typeof t != "string")
      return { status: !1, error: "field-of-array-must-be-string" };
  return { status: !0 };
}
function cs(e) {
  return we.language.includes(e) ? { status: !0 } : { status: !1, error: "language-iso-wrong-language" };
}
function hs(e) {
  return Ci(e);
}
function gs(e) {
  return typeof e != "string" ? { status: !1, error: "embargofct-must-be-string" } : { status: !0 };
}
function ms(e) {
  return we.licenseCondition.includes(e) ? { status: !0 } : { status: !1, error: "rights-uri-wrong-access" };
}
function ys(e) {
  return /\S+@\S+\.\S+/.test(e) ? { status: !0 } : { status: !1, error: "email-invalid-format" };
}
function ps(e) {
  return typeof e != "string" ? { status: !1, error: "institution-name-must-be-string" } : { status: !0 };
}
function bs(e) {
  const t = /^(http(s)?:\/\/)?[(www.)?a-zA-Z0-9%@._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&!//=]*)$/i;
  if (e) {
    if (e.length >= 2e3)
      return { status: !1, error: "max-length-2000" };
    if (!t.test(e))
      return { status: !1, error: "identifier-uri-invalid-format" };
  } else return { status: !1, error: "identifier-uri-must-not-be-empty" };
  return { status: !0 };
}
function _s(e) {
  return we.relatedIdentifierType.includes(e) ? { status: !0 } : { status: !1, error: "relation-type-value-is-not-valid" };
}
function vs(e) {
  return we.version.includes(e) ? { status: !0 } : { status: !1, error: "version-value-is-not-valid" };
}
function Ss(e) {
  return we.peerreviewed.includes(e) ? { status: !0 } : { status: !1, error: "peerreviewed-value-is-not-valid" };
}
function ws(e) {
  return e.length < 2 ? { status: !1, error: "publisher-too-short" } : e.length > 200 ? { status: !1, error: "publisher-too-long" } : { status: !0 };
}
function Ms(e) {
  return /^((http(s)?|ftp(s)?):\/\/)?[(www.)?a-zA-Z0-9%@._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&!//=]*)$/i.exec(e) === null ? { status: !1, error: "publisher-version-failed-url-validation" } : { status: !0 };
}
function ks(e) {
  return e.length < 2 ? { status: !1, error: "citation-title-too-short" } : e.length > 1e3 ? { status: !1, error: "citation-title-too-long" } : { status: !0 };
}
function Ds(e) {
  return e.length < 2 ? { status: !1, error: "citation-place-too-short" } : e.length > 1e3 ? { status: !1, error: "citation-place-too-long" } : { status: !0 };
}
function Os(e) {
  return e.length < 50 ? { status: !0 } : { status: !1, error: "startpage-too-long" };
}
function qs(e) {
  return e.length < 50 ? { status: !0 } : { status: !1, error: "endpage-too-long" };
}
function xs(e) {
  return e.length > 50 ? { status: !1, error: "volume-too-long" } : { status: !0 };
}
function Ts(e) {
  return e.length > 50 ? { status: !1, error: "issue-too-long" } : { status: !0 };
}
function Ys(e) {
  if (/^\d{4}-\d{3}[X\d]$/.exec(e) === null)
    return { status: !1, error: "issn-validation-failed" };
  const r = e.replace("-", "").split("").map((a) => parseInt(a));
  let s = 0;
  for (let a = 0; a < 7; a++)
    s += r[a] * (8 - a);
  const n = (11 - s % 11) % 11;
  if (n === 10) {
    if (e[8] !== "X")
      return { status: !1, error: "issn-validation-failed" };
  } else if (n !== r[7])
    return { status: !1, error: "issn-validation-failed" };
  return { status: !0 };
}
function Is(e) {
  return /^(doi:)?10\.\d{4,9}\/[-.<>_;()/:A-Z0-9a-z]+$/.exec(e) === null ? { status: !1, error: "doi-validation-failed" } : { status: !0 };
}
function As(e) {
  return e.length < 2 ? { status: !1, error: "govdoc-too-short" } : e.length > 50 ? { status: !1, error: "govdoc-too-long" } : { status: !0 };
}
function $s(e) {
  if (e > 1 && e < 99999999)
    return { status: !0 };
}
function js(e) {
  return e.length < 2 ? { status: !1, error: "wos-too-short" } : e.length > 50 ? { status: !1, error: "wos-too-long" } : { status: !0 };
}
function Es(e) {
  const t = /^(?:ISBN(?:-1[03])?:? )?(?=[0-9X]{10}$|(?=(?:[0-9]+[- ]){3})[- 0-9X]{13}$|97[89][0-9]{10}$|(?=(?:[0-9]+[- ]){4})[- 0-9]{17}$)(?:97[89][- ]?)?[0-9]{1,5}[- ]?[0-9]+[- ]?[0-9]+[- ]?[0-9X]$/, i = e;
  if (t.test(e)) {
    const r = i.replace(/[- ]|^ISBN(?:-1[03])?:?/g, "").split(""), s = r.pop();
    let n = 0, a, u;
    if (r.length === 9) {
      for (r.reverse(), u = 0; u < r.length; u++)
        n += (u + 2) * parseInt(r[u], 10);
      a = 11 - n % 11, a === 10 ? a = "X" : a === 11 && (a = "0");
    } else {
      for (u = 0; u < r.length; u++)
        n += (u % 2 * 2 + 1) * parseInt(r[u], 10);
      a = 10 - n % 10, a === 10 && (a = "0");
    }
    return String(a) === s ? { status: !0 } : { status: !1, error: "isbn-validation-failed-last-digit" };
  } else
    return { status: !1, error: "isbn-format-is-invalid" };
}
function Ps(e) {
  return Number.isInteger(e) && parseInt(e) > 0 ? { status: !0 } : { status: !1, error: "should-be-natural-number" };
}
function Cs(e, t) {
  return Bt({ requiredUserId: !0, val: e, ignoreExtraFields: t });
}
function Us(e, t) {
  return Bt({ requiredUserId: !1, val: e, ignoreExtraFields: t });
}
function Ns(e, t) {
  return Bt({ requiredUserId: !1, val: e, ignoreExtraFields: t });
}
function Fs(e) {
  for (const t of e) {
    const i = Ui(t);
    if (!i.status)
      return i;
  }
  return { status: !0 };
}
function Rs(e) {
  for (const t of e) {
    if (typeof t != "object" || t instanceof Array)
      return { status: !1, error: "file-must-be-object" };
    if (t.id) {
      if (typeof t.id != "string")
        return { status: !1, error: "file-id-must-be-of-type-string" };
    } else return { status: !1, error: "file-id-must-be-defined" };
    if (t.mimeType && typeof t.mimeType != "string")
      return { status: !1, error: "file-mimeType-must-be-of-type-string" };
    if (t.rights) {
      const { status: i } = Ci(t.rights);
      if (!i)
        return { status: !1, error: "file-rights-value-is-invalid" };
    }
    if (t.type && !we.fileType.includes(t.type))
      return { status: !1, error: "file-type-value-is-invalid" };
  }
  return { status: !0 };
}
const H = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abstract: ds,
  advisors: Ns,
  citationConferencePlace: Ds,
  citationEdition: Ps,
  citationEndPage: qs,
  citationIssue: Ts,
  citationStartPage: Os,
  citationTitle: ks,
  citationVolume: xs,
  creators: Cs,
  date: Ni,
  degreeName: ls,
  doi: Is,
  editors: Us,
  email: ys,
  embargofct: gs,
  files: Rs,
  fullDate: as,
  fundingReference: Ui,
  fundingReferences: Fs,
  govdoc: As,
  identifierUri: bs,
  institutionName: ps,
  isbn: Es,
  issn: Ys,
  language: cs,
  licenseCondition: ms,
  peerreviewed: Ss,
  pmid: $s,
  publisher: ws,
  publisherVersionUri: Ms,
  relatedIdentifierType: _s,
  rights: hs,
  subject: fs,
  subjectFos: os,
  tid: us,
  title: ss,
  titleAlternative: ns,
  version: vs,
  wos: js
}, Symbol.toStringTag, { value: "Module" }));
var Et, Si;
function Vs() {
  if (Si) return Et;
  Si = 1, Et = {
    compareTwoStrings: e,
    findBestMatch: t
  };
  function e(r, s) {
    if (r = r.replace(/\s+/g, ""), s = s.replace(/\s+/g, ""), r === s) return 1;
    if (r.length < 2 || s.length < 2) return 0;
    let n = /* @__PURE__ */ new Map();
    for (let u = 0; u < r.length - 1; u++) {
      const l = r.substring(u, u + 2), d = n.has(l) ? n.get(l) + 1 : 1;
      n.set(l, d);
    }
    let a = 0;
    for (let u = 0; u < s.length - 1; u++) {
      const l = s.substring(u, u + 2), d = n.has(l) ? n.get(l) : 0;
      d > 0 && (n.set(l, d - 1), a++);
    }
    return 2 * a / (r.length + s.length - 2);
  }
  function t(r, s) {
    if (!i(r, s)) throw new Error("Bad arguments: First argument should be a string, second should be an array of strings");
    const n = [];
    let a = 0;
    for (let l = 0; l < s.length; l++) {
      const d = s[l], _ = e(r, d);
      n.push({ target: d, rating: _ }), _ > n[a].rating && (a = l);
    }
    const u = n[a];
    return { ratings: n, bestMatch: u, bestMatchIndex: a };
  }
  function i(r, s) {
    return !(typeof r != "string" || !Array.isArray(s) || !s.length || s.find(function(n) {
      return typeof n != "string";
    }));
  }
  return Et;
}
var Ws = Vs();
function Ls(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Hs(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function zs(e) {
  return Jt(e);
}
function Bs(e) {
  return Jt(e);
}
function Zs(e) {
  return Jt(e);
}
function Js(e) {
  const t = e.map((i) => {
    let r = 1;
    return i.month && r++, i.day && r++, r;
  });
  return t.includes(3) ? {
    index: t.indexOf(3),
    value: e[t.indexOf(3)]
  } : t.includes(2) ? {
    index: t.indexOf(2),
    value: e[t.indexOf(2)]
  } : {
    index: t.indexOf(1),
    value: e[t.indexOf(1)]
  };
}
function Qs(e) {
  const t = e.map((i) => {
    let r = 1;
    return i.month && r++, i.day && r++, r;
  });
  return t.includes(3) ? {
    index: t.indexOf(3),
    value: e[t.indexOf(3)]
  } : t.includes(2) ? {
    index: t.indexOf(2),
    value: e[t.indexOf(2)]
  } : {
    index: t.indexOf(1),
    value: e[t.indexOf(1)]
  };
}
function Xs(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Ks(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Gs(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function en(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function tn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function rn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function sn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function nn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function an(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function un(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function ln(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function on(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function dn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function fn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function cn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function hn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function gn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function mn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function yn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function pn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function bn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function _n(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function vn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Sn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function wn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Mn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function kn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Dn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function On(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function qn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function xn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Tn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Yn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function In(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function An(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function $n(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function jn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function En(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Pn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Cn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Un(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Nn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Fn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Rn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Vn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Wn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Ln(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Hn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function zn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Bn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Zn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Jn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Qn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Xn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Kn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function Gn(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function ea(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function ta(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function ia(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function ra(e) {
  return {
    index: 0,
    value: e[0]
  };
}
function sa(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((i, r) => {
    i.forEach((s) => {
      t.set(s.checksum, s);
    });
  }), {
    index: 0,
    value: Array.from(t.values())
  };
}
const na = 0.5, Zt = "#$#$#$#$###$#$#$##$#$##$", Fi = (e, t, i) => {
  e.get(Zt).set(t, i);
}, aa = (e, t) => e.get(Zt).get(t), Ri = (e) => {
  let t = -1;
  const i = 0;
  for (let r = 0; r < e.length; r++)
    e[r].length > i && (t = r);
  return t;
}, ua = (e) => {
  const { name: t, ...i } = e.find((r) => r.userId);
  return { name: e[0].name, ...i };
}, la = (e, t) => {
  const i = Ri(e);
  for (const r of e[i])
    for (let s = 0; s < e.length; s++)
      if (s !== i) {
        for (const n of e[s])
          if (!aa(t, n)) {
            const u = Vi({ signature: n.name, signatureToMatch: r.name });
            if (u >= na) {
              let l;
              t.has(r) ? l = t.get(r) : l = /* @__PURE__ */ new Set(), l.add(n), t.set(n, l), Fi(t, n, u);
            }
          }
      }
}, Vi = ({ signature: e, signatureToMatch: t }, { session: i } = {}) => {
  const u = "#$&#$&#$";
  let l = 1;
  const d = e == null ? void 0 : e.toLowerCase().split(/ *, */g).reverse().join(" "), _ = d == null ? void 0 : d.split(/ *- *| *, *| *\. *| +/g), w = t == null ? void 0 : t.toLowerCase().split(/ *, */g).reverse().join(" "), T = w == null ? void 0 : w.split(/ *- *| *, *| *\. *| +/g);
  if (!(_ instanceof Array) || !(T instanceof Array))
    return null;
  const U = [], ee = T.length, he = T.map((W) => W[0]);
  for (const W of _)
    if (W.length > 1) {
      const B = Ws.findBestMatch(W, T);
      if (B.bestMatch.rating > 0.5)
        U.push(B.bestMatchIndex), T[B.bestMatchIndex] = u, he[B.bestMatchIndex] = u;
      else {
        let te = -1;
        for (let ie = 0; ie < T.length; ie++)
          if (T[ie].length === 1 && W[0] === T[ie]) {
            te = ie;
            break;
          }
        U.push(te), T[te] = u, he[te] = u;
      }
    } else if (W.length === 1) {
      let B = -1;
      for (let te = 0; te < he.length; te++)
        if (W[0] === he[te]) {
          B = te;
          break;
        }
      U.push(B), T[B] = u, he[B] = u;
    }
  _.length < 2 && ee > 1 && (l = l - 0.6);
  let ue = 0, He = _.length;
  for (let W = 0; W < U.length; ++W)
    U[W] === -1 && He--, U[W] < ue ? l = l - 0.3 : ue = U[W];
  return He === 0 ? l = 0 : He === 1 && (l = l - 0.4), l > 0 ? l : 0;
}, oa = (e, t) => {
  for (const i of e)
    for (const r of i)
      if (r.userId) {
        let s = /* @__PURE__ */ new Set();
        t.has(r) && (s = t.get(r)), s.add(r), t.set(r, s), Fi(t, r, 1);
      }
}, da = (e, t) => {
  const i = Array.from(t.keys()).filter((r) => typeof r != "string" && r.userId);
  for (const r of i)
    if (e.filter((s) => (s == null ? void 0 : s.userId) === r.userId).length === 0) {
      const s = e.filter((u) => !u.userId), { index: n, score: a } = fa({ signatures: s.map((u) => u.name), signatureToMatch: r.name });
      s.length === 0 || a < 0.3 ? e.push(r) : (s[n].userId = r.userId, r.user && (s[n].user = r.user));
    }
}, fa = ({ signatures: e, signatureToMatch: t }) => {
  let i = 0, r = 0, s = "";
  for (let n = 0; n < e.length; ++n) {
    const a = Vi({ signature: e[n], signatureToMatch: t });
    a > i && (r = n, i = a, s = e[n]);
  }
  return { index: r, score: i, signature: s };
}, ca = (e) => {
  const t = JSON.parse(JSON.stringify(e)), i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  i.set(Zt, r), oa(t, i), la(t, i);
  const s = Ri(t), n = [];
  for (const a of t[s])
    i.has(a) ? n.push(ua([a, ...i.get(a)])) : n.push(a);
  return da(n, i), { index: 0, value: n };
}, Jt = (e) => ca(e), Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abstract: rn,
  address: Fn,
  advisors: Zs,
  aprovaldate: Jn,
  authorEmail: fn,
  booktitle: Ln,
  chapter: Wn,
  citationConferenceDate: Xs,
  citationConferencePlace: $n,
  citationEdition: Un,
  citationEndPage: Cn,
  citationIssue: En,
  citationStartPage: Pn,
  citationTitle: An,
  citationVolume: jn,
  comments: dn,
  creators: zs,
  date: Js,
  degreeName: Gs,
  doi: Mn,
  editors: Bs,
  email: ia,
  embargofct: ln,
  event: Gn,
  files: sa,
  fullDate: Qs,
  fundingReference: ta,
  fundingReferences: tn,
  govdoc: Dn,
  howpublished: Vn,
  identifierUri: cn,
  institution: zn,
  institutionName: ra,
  isbn: kn,
  issn: qn,
  issue: _n,
  journal: pn,
  keyword: Tn,
  language: nn,
  licenseCondition: ea,
  location: Xn,
  month: wn,
  number: vn,
  organization: Hn,
  pages: Sn,
  patentstatus: Kn,
  peerreviewed: mn,
  pmid: On,
  publisher: Yn,
  publisherVersionUri: In,
  reference: Zn,
  registrationdate: Qn,
  relatedIdentifierType: hn,
  relation: an,
  rights: un,
  school: Bn,
  series: Nn,
  sponsorship: on,
  subject: sn,
  subjectFos: en,
  tid: Ks,
  title: Ls,
  titleAlternative: Hs,
  url: Rn,
  version: gn,
  volume: bn,
  wos: xn,
  year: yn
}, Symbol.toStringTag, { value: "Module" }));
function ha(e) {
  return null;
}
function ga(e) {
  return null;
}
function ma(e) {
  return null;
}
function ya(e) {
  return null;
}
function pa(e) {
  return null;
}
function ba(e) {
  return null;
}
function _a(e) {
  return null;
}
function va(e) {
  return null;
}
function Sa(e) {
  return e.extra.fos && Ai.includes(e.extra.fos) ? e.extra.fos : null;
}
function wa(e) {
  return null;
}
function Ma(e) {
  return null;
}
function ka(e) {
  return e.extra.defaultLanguage && Ei.includes(e.extra.defaultLanguage) ? e.extra.defaultLanguage : null;
}
function Da(e) {
  return "metadata-only-access";
}
function Oa(e) {
  return null;
}
function qa(e) {
  return null;
}
function xa(e) {
  return null;
}
function Ta(e) {
  return null;
}
function Ya(e) {
  return null;
}
function Ia(e) {
  return null;
}
function Aa(e) {
  return null;
}
function $a(e) {
  return "P";
}
function ja(e) {
  return null;
}
function Ea(e) {
  return null;
}
function Pa(e) {
  return null;
}
function Ca(e) {
  return null;
}
function Ua(e) {
  return null;
}
function Na(e) {
  return null;
}
function Fa(e) {
  return null;
}
function Ra(e) {
  return null;
}
function Va(e) {
  return null;
}
function Wa(e) {
  return null;
}
function La(e) {
  return null;
}
function Ha(e) {
  return null;
}
function za(e) {
  return null;
}
function Ba(e) {
  return null;
}
function Za(e) {
  return null;
}
function Ja(e) {
  return null;
}
function Qa(e) {
  return null;
}
function Xa(e) {
  return null;
}
function Ka(e) {
  return null;
}
function Ga(e) {
  return null;
}
function eu(e) {
  return null;
}
function tu(e) {
  return null;
}
const J = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abstract: wa,
  advisors: Ga,
  authorEmail: Ya,
  citationConferenceDate: Na,
  citationConferencePlace: Ua,
  citationEdition: La,
  citationEndPage: Ra,
  citationIssue: Wa,
  citationStartPage: Fa,
  citationTitle: Ca,
  citationVolume: Va,
  creators: Xa,
  dateAccepted: ya,
  dateAvailable: pa,
  dateIssued: ma,
  degreeName: va,
  description: ba,
  doi: za,
  editors: Ka,
  email: xa,
  embargofct: Oa,
  files: tu,
  fundingReferences: eu,
  govdoc: Ba,
  identifierUri: Ia,
  institutionName: Ta,
  isbn: Qa,
  issn: Ha,
  language: ka,
  licenseCondition: qa,
  peerreviewed: ja,
  pmid: Za,
  publisher: Ea,
  publisherVersionUri: Pa,
  relatedIdentifierType: Aa,
  rights: Da,
  subject: Ma,
  subjectFos: Sa,
  tid: _a,
  title: ha,
  titleAlternative: ga,
  version: $a,
  wos: Ja
}, Symbol.toStringTag, { value: "Module" })), hf = ["bibtex"];
class iu {
  /**
   * @param {import('#src/parsers/Parser').default} parser The parser to use in the formatter
   * @param {object} metadata The metadata to convert
   * @param {string} fileType ?
   * @param {string} contentType ?
   */
  constructor(t, i, r, s) {
    this.metadata = i, this.parser = t, this.fileType = r, this.contentType = s;
  }
  output() {
    return {
      content: this.implementOutput(),
      fileType: this.fileType,
      contentType: this.contentType
    };
  }
}
class ru extends iu {
  constructor(t, i) {
    super(t, i, "bib", "application/x-bibtex");
  }
  implementOutput() {
    if (!this.verifyMetadata())
      return "";
    let t = this.getType() + "{" + this.generateRefName() + `
`;
    return t += "title = {{" + this.metadata.title + `}},
`, t += "author = {" + this.generateAuthors() + `},
`, this.metadata.dateIssued && (this.metadata.dateIssued.month && (t += "month = " + this.getMonth() + `,
`), t += "year = {" + this.metadata.dateIssued.year + `},
`), this.metadata.publisher && (t += "publisher = {" + this.metadata.publisher + `},
`), this.metadata.citationTitle && (t += "booktitle = {{" + this.metadata.citationTitle + `}},
`), this.metadata.citationStartPage && this.metadata.citationEndPage && (t += "pages = {" + this.metadata.citationStartPage + "--" + this.metadata.citationEndPage + `},
`), this.metadata.citationVolume && (t += "volume = {" + this.metadata.citationVolume + `},
`), this.metadata.citationIssue && (t += "number = {" + this.metadata.citationIssue + `},
`), this.metadata.issn && (t += "issn = {" + this.metadata.issn + `},
`), this.metadata.doi && (t += "doi = {" + this.metadata.doi + `},
`), this.metadata.description && (t += "abstract = {{" + this.metadata.description + `}},
`), this.metadata.subject && (t += "keywords = {" + this.metadata.subject.join(",") + `},
`), t.includes("@misc") && this.metadata.type && (t += "type = {" + this.metadata.type + `},
`), this.metadata.language && (t += "language = {" + this.metadata.language + `},
`), this.metadata.rights && (t += "copyright = {" + this.metadata.rights + `},
`), this.metadata.identifierUri && (t += "url = {" + this.metadata.identifierUri + `},
`), this.metadata.authorEmail && (t += "Email = {" + this.metadata.authorEmail + `},
`), t + `
}`;
  }
  getType() {
    switch (this.metadata.type) {
      case "journal-article":
        return "@article";
      case "article":
        return "@article";
      case "book":
        return "@book";
      case "book-part":
        return "@book";
      case "conference-object":
        return "@inproceedings";
      case "doctoral-thesis":
        return "@phdthesis";
      case "master-thesis":
        return "@mastersthesis";
      case "report":
        return "@techreport";
      default:
        return "@misc";
    }
  }
  generateRefName() {
    const t = this.metadata.creators[0].name.split(" ");
    return (t[t.length - 1] + "-" + this.metadata.title).normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").replace(/ /g, "-").replace(/[^a-zA-Z0-9:;\-/.]/g, "") + ",";
  }
  verifyMetadata() {
    return !(!this.metadata.title || this.metadata.title.length === 0) && !(!this.metadata.creators || this.metadata.creators.length === 0);
  }
  getMonth() {
    switch (this.metadata.dateIssued.month) {
      case 1:
        return "jan";
      case 2:
        return "feb";
      case 3:
        return "mar";
      case 4:
        return "apr";
      case 5:
        return "may";
      case 6:
        return "jun";
      case 7:
        return "jul";
      case 8:
        return "aug";
      case 9:
        return "sep";
      case 10:
        return "oct";
      case 11:
        return "nov";
      case 12:
        return "dec";
      default:
        return "";
    }
  }
  generateAuthors() {
    const t = [];
    for (const i of this.metadata.creators) {
      if (i.name.indexOf(",") > 0) {
        t.push(i.name);
        continue;
      }
      const r = i.name.split(" ");
      if (r.length === 1) {
        t.push(r[0]);
        continue;
      }
      let s = "", n = [];
      for (let a = 0; a < r.length - 1; a++)
        r[a] === r[a].toLowerCase() ? n.push(r[a]) : n.length > 0 ? (s += `{${n.join(" ")} ${r[a]}} `, n = []) : s += r[a] + " ";
      n.push(r[r.length - 1]), s = n.join(" ") + ", " + s.trim(), t.push(s);
    }
    return t.join(" and ");
  }
}
var ct = { exports: {} }, su = ct.exports, wi;
function nu() {
  return wi || (wi = 1, (function(e, t) {
    (function(i, r) {
      e.exports = r(Ii());
    })(su, (function(i) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var s = r(i), n = { name: "pt", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sab".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sa".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(a) {
        return a + "º";
      }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "alguns segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
      return s.default.locale(n, null, !0), n;
    }));
  })(ct)), ct.exports;
}
nu();
var ht = { exports: {} }, au = ht.exports, Mi;
function uu() {
  return Mi || (Mi = 1, (function(e, t) {
    (function(i, r) {
      e.exports = r();
    })(au, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") };
    }));
  })(ht)), ht.exports;
}
uu();
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Wi;
function f() {
  return Wi.apply(null, arguments);
}
function lu(e) {
  Wi = e;
}
function se(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function $e(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function O(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Qt(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (O(e, t))
      return !1;
  return !0;
}
function z(e) {
  return e === void 0;
}
function Se(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function it(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Li(e, t) {
  var i = [], r, s = e.length;
  for (r = 0; r < s; ++r)
    i.push(t(e[r], r));
  return i;
}
function qe(e, t) {
  for (var i in t)
    O(t, i) && (e[i] = t[i]);
  return O(t, "toString") && (e.toString = t.toString), O(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function fe(e, t, i, r) {
  return hr(e, t, i, r, !0).utc();
}
function ou() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function v(e) {
  return e._pf == null && (e._pf = ou()), e._pf;
}
var Ft;
Array.prototype.some ? Ft = Array.prototype.some : Ft = function(e) {
  var t = Object(this), i = t.length >>> 0, r;
  for (r = 0; r < i; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function Xt(e) {
  var t = null, i = !1, r = e._d && !isNaN(e._d.getTime());
  if (r && (t = v(e), i = Ft.call(t.parsedDateParts, function(s) {
    return s != null;
  }), r = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && i), e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = r;
  else
    return r;
  return e._isValid;
}
function wt(e) {
  var t = fe(NaN);
  return e != null ? qe(v(t), e) : v(t).userInvalidated = !0, t;
}
var ki = f.momentProperties = [], Pt = !1;
function Kt(e, t) {
  var i, r, s, n = ki.length;
  if (z(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), z(t._i) || (e._i = t._i), z(t._f) || (e._f = t._f), z(t._l) || (e._l = t._l), z(t._strict) || (e._strict = t._strict), z(t._tzm) || (e._tzm = t._tzm), z(t._isUTC) || (e._isUTC = t._isUTC), z(t._offset) || (e._offset = t._offset), z(t._pf) || (e._pf = v(t)), z(t._locale) || (e._locale = t._locale), n > 0)
    for (i = 0; i < n; i++)
      r = ki[i], s = t[r], z(s) || (e[r] = s);
  return e;
}
function rt(e) {
  Kt(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Pt === !1 && (Pt = !0, f.updateOffset(this), Pt = !1);
}
function ne(e) {
  return e instanceof rt || e != null && e._isAMomentObject != null;
}
function Hi(e) {
  f.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function K(e, t) {
  var i = !0;
  return qe(function() {
    if (f.deprecationHandler != null && f.deprecationHandler(null, e), i) {
      var r = [], s, n, a, u = arguments.length;
      for (n = 0; n < u; n++) {
        if (s = "", typeof arguments[n] == "object") {
          s += `
[` + n + "] ";
          for (a in arguments[0])
            O(arguments[0], a) && (s += a + ": " + arguments[0][a] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[n];
        r.push(s);
      }
      Hi(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), i = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Di = {};
function zi(e, t) {
  f.deprecationHandler != null && f.deprecationHandler(e, t), Di[e] || (Hi(t), Di[e] = !0);
}
f.suppressDeprecationWarnings = !1;
f.deprecationHandler = null;
function ce(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function du(e) {
  var t, i;
  for (i in e)
    O(e, i) && (t = e[i], ce(t) ? this[i] = t : this["_" + i] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Rt(e, t) {
  var i = qe({}, e), r;
  for (r in t)
    O(t, r) && ($e(e[r]) && $e(t[r]) ? (i[r] = {}, qe(i[r], e[r]), qe(i[r], t[r])) : t[r] != null ? i[r] = t[r] : delete i[r]);
  for (r in e)
    O(e, r) && !O(t, r) && $e(e[r]) && (i[r] = qe({}, i[r]));
  return i;
}
function Gt(e) {
  e != null && this.set(e);
}
var Vt;
Object.keys ? Vt = Object.keys : Vt = function(e) {
  var t, i = [];
  for (t in e)
    O(e, t) && i.push(t);
  return i;
};
var fu = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function cu(e, t, i) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return ce(r) ? r.call(t, i) : r;
}
function oe(e, t, i) {
  var r = "" + Math.abs(e), s = t - r.length, n = e >= 0;
  return (n ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + r;
}
var ei = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ot = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Ct = {}, Ne = {};
function y(e, t, i, r) {
  var s = r;
  typeof r == "string" && (s = function() {
    return this[r]();
  }), e && (Ne[e] = s), t && (Ne[t[0]] = function() {
    return oe(s.apply(this, arguments), t[1], t[2]);
  }), i && (Ne[i] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      e
    );
  });
}
function hu(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function gu(e) {
  var t = e.match(ei), i, r;
  for (i = 0, r = t.length; i < r; i++)
    Ne[t[i]] ? t[i] = Ne[t[i]] : t[i] = hu(t[i]);
  return function(s) {
    var n = "", a;
    for (a = 0; a < r; a++)
      n += ce(t[a]) ? t[a].call(s, e) : t[a];
    return n;
  };
}
function gt(e, t) {
  return e.isValid() ? (t = Bi(t, e.localeData()), Ct[t] = Ct[t] || gu(t), Ct[t](e)) : e.localeData().invalidDate();
}
function Bi(e, t) {
  var i = 5;
  function r(s) {
    return t.longDateFormat(s) || s;
  }
  for (ot.lastIndex = 0; i >= 0 && ot.test(e); )
    e = e.replace(
      ot,
      r
    ), ot.lastIndex = 0, i -= 1;
  return e;
}
var mu = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function yu(e) {
  var t = this._longDateFormat[e], i = this._longDateFormat[e.toUpperCase()];
  return t || !i ? t : (this._longDateFormat[e] = i.match(ei).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var pu = "Invalid date";
function bu() {
  return this._invalidDate;
}
var _u = "%d", vu = /\d{1,2}/;
function Su(e) {
  return this._ordinal.replace("%d", e);
}
var wu = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Mu(e, t, i, r) {
  var s = this._relativeTime[i];
  return ce(s) ? s(e, t, i, r) : s.replace(/%d/i, e);
}
function ku(e, t) {
  var i = this._relativeTime[e > 0 ? "future" : "past"];
  return ce(i) ? i(t) : i.replace(/%s/i, t);
}
var Oi = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function G(e) {
  return typeof e == "string" ? Oi[e] || Oi[e.toLowerCase()] : void 0;
}
function ti(e) {
  var t = {}, i, r;
  for (r in e)
    O(e, r) && (i = G(r), i && (t[i] = e[r]));
  return t;
}
var Du = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Ou(e) {
  var t = [], i;
  for (i in e)
    O(e, i) && t.push({ unit: i, priority: Du[i] });
  return t.sort(function(r, s) {
    return r.priority - s.priority;
  }), t;
}
var Zi = /\d/, Q = /\d\d/, Ji = /\d{3}/, ii = /\d{4}/, Mt = /[+-]?\d{6}/, $ = /\d\d?/, Qi = /\d\d\d\d?/, Xi = /\d\d\d\d\d\d?/, kt = /\d{1,3}/, ri = /\d{1,4}/, Dt = /[+-]?\d{1,6}/, Ve = /\d+/, Ot = /[+-]?\d+/, qu = /Z|[+-]\d\d:?\d\d/gi, qt = /Z|[+-]\d\d(?::?\d\d)?/gi, xu = /[+-]?\d+(\.\d{1,3})?/, st = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, We = /^[1-9]\d?/, si = /^([1-9]\d|\d)/, pt;
pt = {};
function h(e, t, i) {
  pt[e] = ce(t) ? t : function(r, s) {
    return r && i ? i : t;
  };
}
function Tu(e, t) {
  return O(pt, e) ? pt[e](t._strict, t._locale) : new RegExp(Yu(e));
}
function Yu(e) {
  return _e(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, i, r, s, n) {
        return i || r || s || n;
      }
    )
  );
}
function _e(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function X(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function M(e) {
  var t = +e, i = 0;
  return t !== 0 && isFinite(t) && (i = X(t)), i;
}
var Wt = {};
function x(e, t) {
  var i, r = t, s;
  for (typeof e == "string" && (e = [e]), Se(t) && (r = function(n, a) {
    a[t] = M(n);
  }), s = e.length, i = 0; i < s; i++)
    Wt[e[i]] = r;
}
function nt(e, t) {
  x(e, function(i, r, s, n) {
    s._w = s._w || {}, t(i, s._w, s, n);
  });
}
function Iu(e, t, i) {
  t != null && O(Wt, e) && Wt[e](t, i._a, i, e);
}
function xt(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var V = 0, pe = 1, le = 2, N = 3, re = 4, be = 5, Ae = 6, Au = 7, $u = 8;
y("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? oe(e, 4) : "+" + e;
});
y(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
y(0, ["YYYY", 4], 0, "year");
y(0, ["YYYYY", 5], 0, "year");
y(0, ["YYYYYY", 6, !0], 0, "year");
h("Y", Ot);
h("YY", $, Q);
h("YYYY", ri, ii);
h("YYYYY", Dt, Mt);
h("YYYYYY", Dt, Mt);
x(["YYYYY", "YYYYYY"], V);
x("YYYY", function(e, t) {
  t[V] = e.length === 2 ? f.parseTwoDigitYear(e) : M(e);
});
x("YY", function(e, t) {
  t[V] = f.parseTwoDigitYear(e);
});
x("Y", function(e, t) {
  t[V] = parseInt(e, 10);
});
function Xe(e) {
  return xt(e) ? 366 : 365;
}
f.parseTwoDigitYear = function(e) {
  return M(e) + (M(e) > 68 ? 1900 : 2e3);
};
var Ki = Le("FullYear", !0);
function ju() {
  return xt(this.year());
}
function Le(e, t) {
  return function(i) {
    return i != null ? (Gi(this, e, i), f.updateOffset(this, t), this) : Ke(this, e);
  };
}
function Ke(e, t) {
  if (!e.isValid())
    return NaN;
  var i = e._d, r = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return r ? i.getUTCMilliseconds() : i.getMilliseconds();
    case "Seconds":
      return r ? i.getUTCSeconds() : i.getSeconds();
    case "Minutes":
      return r ? i.getUTCMinutes() : i.getMinutes();
    case "Hours":
      return r ? i.getUTCHours() : i.getHours();
    case "Date":
      return r ? i.getUTCDate() : i.getDate();
    case "Day":
      return r ? i.getUTCDay() : i.getDay();
    case "Month":
      return r ? i.getUTCMonth() : i.getMonth();
    case "FullYear":
      return r ? i.getUTCFullYear() : i.getFullYear();
    default:
      return NaN;
  }
}
function Gi(e, t, i) {
  var r, s, n, a, u;
  if (!(!e.isValid() || isNaN(i))) {
    switch (r = e._d, s = e._isUTC, t) {
      case "Milliseconds":
        return void (s ? r.setUTCMilliseconds(i) : r.setMilliseconds(i));
      case "Seconds":
        return void (s ? r.setUTCSeconds(i) : r.setSeconds(i));
      case "Minutes":
        return void (s ? r.setUTCMinutes(i) : r.setMinutes(i));
      case "Hours":
        return void (s ? r.setUTCHours(i) : r.setHours(i));
      case "Date":
        return void (s ? r.setUTCDate(i) : r.setDate(i));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    n = i, a = e.month(), u = e.date(), u = u === 29 && a === 1 && !xt(n) ? 28 : u, s ? r.setUTCFullYear(n, a, u) : r.setFullYear(n, a, u);
  }
}
function Eu(e) {
  return e = G(e), ce(this[e]) ? this[e]() : this;
}
function Pu(e, t) {
  if (typeof e == "object") {
    e = ti(e);
    var i = Ou(e), r, s = i.length;
    for (r = 0; r < s; r++)
      this[i[r].unit](e[i[r].unit]);
  } else if (e = G(e), ce(this[e]))
    return this[e](t);
  return this;
}
function Cu(e, t) {
  return (e % t + t) % t;
}
var P;
Array.prototype.indexOf ? P = Array.prototype.indexOf : P = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function ni(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var i = Cu(t, 12);
  return e += (t - i) / 12, i === 1 ? xt(e) ? 29 : 28 : 31 - i % 7 % 2;
}
y("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
y("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
y("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
h("M", $, We);
h("MM", $, Q);
h("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
h("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
x(["M", "MM"], function(e, t) {
  t[pe] = M(e) - 1;
});
x(["MMM", "MMMM"], function(e, t, i, r) {
  var s = i._locale.monthsParse(e, r, i._strict);
  s != null ? t[pe] = s : v(i).invalidMonth = e;
});
var Uu = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), er = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), tr = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Nu = st, Fu = st;
function Ru(e, t) {
  return e ? se(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || tr).test(t) ? "format" : "standalone"][e.month()] : se(this._months) ? this._months : this._months.standalone;
}
function Vu(e, t) {
  return e ? se(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[tr.test(t) ? "format" : "standalone"][e.month()] : se(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Wu(e, t, i) {
  var r, s, n, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      n = fe([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        n,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(n, "").toLocaleLowerCase();
  return i ? t === "MMM" ? (s = P.call(this._shortMonthsParse, a), s !== -1 ? s : null) : (s = P.call(this._longMonthsParse, a), s !== -1 ? s : null) : t === "MMM" ? (s = P.call(this._shortMonthsParse, a), s !== -1 ? s : (s = P.call(this._longMonthsParse, a), s !== -1 ? s : null)) : (s = P.call(this._longMonthsParse, a), s !== -1 ? s : (s = P.call(this._shortMonthsParse, a), s !== -1 ? s : null));
}
function Lu(e, t, i) {
  var r, s, n;
  if (this._monthsParseExact)
    return Wu.call(this, e, t, i);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (s = fe([2e3, r]), i && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !i && !this._monthsParse[r] && (n = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[r] = new RegExp(n.replace(".", ""), "i")), i && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (i && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!i && this._monthsParse[r].test(e))
      return r;
  }
}
function ir(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = M(t);
    else if (t = e.localeData().monthsParse(t), !Se(t))
      return e;
  }
  var i = t, r = e.date();
  return r = r < 29 ? r : Math.min(r, ni(e.year(), i)), e._isUTC ? e._d.setUTCMonth(i, r) : e._d.setMonth(i, r), e;
}
function rr(e) {
  return e != null ? (ir(this, e), f.updateOffset(this, !0), this) : Ke(this, "Month");
}
function Hu() {
  return ni(this.year(), this.month());
}
function zu(e) {
  return this._monthsParseExact ? (O(this, "_monthsRegex") || sr.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (O(this, "_monthsShortRegex") || (this._monthsShortRegex = Nu), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Bu(e) {
  return this._monthsParseExact ? (O(this, "_monthsRegex") || sr.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (O(this, "_monthsRegex") || (this._monthsRegex = Fu), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function sr() {
  function e(l, d) {
    return d.length - l.length;
  }
  var t = [], i = [], r = [], s, n, a, u;
  for (s = 0; s < 12; s++)
    n = fe([2e3, s]), a = _e(this.monthsShort(n, "")), u = _e(this.months(n, "")), t.push(a), i.push(u), r.push(u), r.push(a);
  t.sort(e), i.sort(e), r.sort(e), this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Zu(e, t, i, r, s, n, a) {
  var u;
  return e < 100 && e >= 0 ? (u = new Date(e + 400, t, i, r, s, n, a), isFinite(u.getFullYear()) && u.setFullYear(e)) : u = new Date(e, t, i, r, s, n, a), u;
}
function Ge(e) {
  var t, i;
  return e < 100 && e >= 0 ? (i = Array.prototype.slice.call(arguments), i[0] = e + 400, t = new Date(Date.UTC.apply(null, i)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function bt(e, t, i) {
  var r = 7 + t - i, s = (7 + Ge(e, 0, r).getUTCDay() - t) % 7;
  return -s + r - 1;
}
function nr(e, t, i, r, s) {
  var n = (7 + i - r) % 7, a = bt(e, r, s), u = 1 + 7 * (t - 1) + n + a, l, d;
  return u <= 0 ? (l = e - 1, d = Xe(l) + u) : u > Xe(e) ? (l = e + 1, d = u - Xe(e)) : (l = e, d = u), {
    year: l,
    dayOfYear: d
  };
}
function et(e, t, i) {
  var r = bt(e.year(), t, i), s = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, n, a;
  return s < 1 ? (a = e.year() - 1, n = s + ve(a, t, i)) : s > ve(e.year(), t, i) ? (n = s - ve(e.year(), t, i), a = e.year() + 1) : (a = e.year(), n = s), {
    week: n,
    year: a
  };
}
function ve(e, t, i) {
  var r = bt(e, t, i), s = bt(e + 1, t, i);
  return (Xe(e) - r + s) / 7;
}
y("w", ["ww", 2], "wo", "week");
y("W", ["WW", 2], "Wo", "isoWeek");
h("w", $, We);
h("ww", $, Q);
h("W", $, We);
h("WW", $, Q);
nt(
  ["w", "ww", "W", "WW"],
  function(e, t, i, r) {
    t[r.substr(0, 1)] = M(e);
  }
);
function Ju(e) {
  return et(e, this._week.dow, this._week.doy).week;
}
var Qu = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Xu() {
  return this._week.dow;
}
function Ku() {
  return this._week.doy;
}
function Gu(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function el(e) {
  var t = et(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
y("d", 0, "do", "day");
y("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
y("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
y("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
y("e", 0, 0, "weekday");
y("E", 0, 0, "isoWeekday");
h("d", $);
h("e", $);
h("E", $);
h("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
h("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
h("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
nt(["dd", "ddd", "dddd"], function(e, t, i, r) {
  var s = i._locale.weekdaysParse(e, r, i._strict);
  s != null ? t.d = s : v(i).invalidWeekday = e;
});
nt(["d", "e", "E"], function(e, t, i, r) {
  t[r] = M(e);
});
function tl(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function il(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function ai(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var rl = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ar = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), sl = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), nl = st, al = st, ul = st;
function ll(e, t) {
  var i = se(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? ai(i, this._week.dow) : e ? i[e.day()] : i;
}
function ol(e) {
  return e === !0 ? ai(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function dl(e) {
  return e === !0 ? ai(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function fl(e, t, i) {
  var r, s, n, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      n = fe([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        n,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        n,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(n, "").toLocaleLowerCase();
  return i ? t === "dddd" ? (s = P.call(this._weekdaysParse, a), s !== -1 ? s : null) : t === "ddd" ? (s = P.call(this._shortWeekdaysParse, a), s !== -1 ? s : null) : (s = P.call(this._minWeekdaysParse, a), s !== -1 ? s : null) : t === "dddd" ? (s = P.call(this._weekdaysParse, a), s !== -1 || (s = P.call(this._shortWeekdaysParse, a), s !== -1) ? s : (s = P.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : t === "ddd" ? (s = P.call(this._shortWeekdaysParse, a), s !== -1 || (s = P.call(this._weekdaysParse, a), s !== -1) ? s : (s = P.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : (s = P.call(this._minWeekdaysParse, a), s !== -1 || (s = P.call(this._weekdaysParse, a), s !== -1) ? s : (s = P.call(this._shortWeekdaysParse, a), s !== -1 ? s : null));
}
function cl(e, t, i) {
  var r, s, n;
  if (this._weekdaysParseExact)
    return fl.call(this, e, t, i);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (s = fe([2e3, 1]).day(r), i && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (n = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[r] = new RegExp(n.replace(".", ""), "i")), i && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (i && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (i && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!i && this._weekdaysParse[r].test(e))
      return r;
  }
}
function hl(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Ke(this, "Day");
  return e != null ? (e = tl(e, this.localeData()), this.add(e - t, "d")) : t;
}
function gl(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function ml(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = il(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function yl(e) {
  return this._weekdaysParseExact ? (O(this, "_weekdaysRegex") || ui.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (O(this, "_weekdaysRegex") || (this._weekdaysRegex = nl), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function pl(e) {
  return this._weekdaysParseExact ? (O(this, "_weekdaysRegex") || ui.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (O(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = al), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function bl(e) {
  return this._weekdaysParseExact ? (O(this, "_weekdaysRegex") || ui.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (O(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = ul), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function ui() {
  function e(_, w) {
    return w.length - _.length;
  }
  var t = [], i = [], r = [], s = [], n, a, u, l, d;
  for (n = 0; n < 7; n++)
    a = fe([2e3, 1]).day(n), u = _e(this.weekdaysMin(a, "")), l = _e(this.weekdaysShort(a, "")), d = _e(this.weekdays(a, "")), t.push(u), i.push(l), r.push(d), s.push(u), s.push(l), s.push(d);
  t.sort(e), i.sort(e), r.sort(e), s.sort(e), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function li() {
  return this.hours() % 12 || 12;
}
function _l() {
  return this.hours() || 24;
}
y("H", ["HH", 2], 0, "hour");
y("h", ["hh", 2], 0, li);
y("k", ["kk", 2], 0, _l);
y("hmm", 0, 0, function() {
  return "" + li.apply(this) + oe(this.minutes(), 2);
});
y("hmmss", 0, 0, function() {
  return "" + li.apply(this) + oe(this.minutes(), 2) + oe(this.seconds(), 2);
});
y("Hmm", 0, 0, function() {
  return "" + this.hours() + oe(this.minutes(), 2);
});
y("Hmmss", 0, 0, function() {
  return "" + this.hours() + oe(this.minutes(), 2) + oe(this.seconds(), 2);
});
function ur(e, t) {
  y(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
ur("a", !0);
ur("A", !1);
function lr(e, t) {
  return t._meridiemParse;
}
h("a", lr);
h("A", lr);
h("H", $, si);
h("h", $, We);
h("k", $, We);
h("HH", $, Q);
h("hh", $, Q);
h("kk", $, Q);
h("hmm", Qi);
h("hmmss", Xi);
h("Hmm", Qi);
h("Hmmss", Xi);
x(["H", "HH"], N);
x(["k", "kk"], function(e, t, i) {
  var r = M(e);
  t[N] = r === 24 ? 0 : r;
});
x(["a", "A"], function(e, t, i) {
  i._isPm = i._locale.isPM(e), i._meridiem = e;
});
x(["h", "hh"], function(e, t, i) {
  t[N] = M(e), v(i).bigHour = !0;
});
x("hmm", function(e, t, i) {
  var r = e.length - 2;
  t[N] = M(e.substr(0, r)), t[re] = M(e.substr(r)), v(i).bigHour = !0;
});
x("hmmss", function(e, t, i) {
  var r = e.length - 4, s = e.length - 2;
  t[N] = M(e.substr(0, r)), t[re] = M(e.substr(r, 2)), t[be] = M(e.substr(s)), v(i).bigHour = !0;
});
x("Hmm", function(e, t, i) {
  var r = e.length - 2;
  t[N] = M(e.substr(0, r)), t[re] = M(e.substr(r));
});
x("Hmmss", function(e, t, i) {
  var r = e.length - 4, s = e.length - 2;
  t[N] = M(e.substr(0, r)), t[re] = M(e.substr(r, 2)), t[be] = M(e.substr(s));
});
function vl(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Sl = /[ap]\.?m?\.?/i, wl = Le("Hours", !0);
function Ml(e, t, i) {
  return e > 11 ? i ? "pm" : "PM" : i ? "am" : "AM";
}
var or = {
  calendar: fu,
  longDateFormat: mu,
  invalidDate: pu,
  ordinal: _u,
  dayOfMonthOrdinalParse: vu,
  relativeTime: wu,
  months: Uu,
  monthsShort: er,
  week: Qu,
  weekdays: rl,
  weekdaysMin: sl,
  weekdaysShort: ar,
  meridiemParse: Sl
}, j = {}, Je = {}, tt;
function kl(e, t) {
  var i, r = Math.min(e.length, t.length);
  for (i = 0; i < r; i += 1)
    if (e[i] !== t[i])
      return i;
  return r;
}
function qi(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Dl(e) {
  for (var t = 0, i, r, s, n; t < e.length; ) {
    for (n = qi(e[t]).split("-"), i = n.length, r = qi(e[t + 1]), r = r ? r.split("-") : null; i > 0; ) {
      if (s = Tt(n.slice(0, i).join("-")), s)
        return s;
      if (r && r.length >= i && kl(n, r) >= i - 1)
        break;
      i--;
    }
    t++;
  }
  return tt;
}
function Ol(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function Tt(e) {
  var t = null, i;
  if (j[e] === void 0 && typeof module < "u" && module && module.exports && Ol(e))
    try {
      t = tt._abbr, i = require, i("./locale/" + e), Te(t);
    } catch {
      j[e] = null;
    }
  return j[e];
}
function Te(e, t) {
  var i;
  return e && (z(t) ? i = Me(e) : i = oi(e, t), i ? tt = i : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), tt._abbr;
}
function oi(e, t) {
  if (t !== null) {
    var i, r = or;
    if (t.abbr = e, j[e] != null)
      zi(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = j[e]._config;
    else if (t.parentLocale != null)
      if (j[t.parentLocale] != null)
        r = j[t.parentLocale]._config;
      else if (i = Tt(t.parentLocale), i != null)
        r = i._config;
      else
        return Je[t.parentLocale] || (Je[t.parentLocale] = []), Je[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return j[e] = new Gt(Rt(r, t)), Je[e] && Je[e].forEach(function(s) {
      oi(s.name, s.config);
    }), Te(e), j[e];
  } else
    return delete j[e], null;
}
function ql(e, t) {
  if (t != null) {
    var i, r, s = or;
    j[e] != null && j[e].parentLocale != null ? j[e].set(Rt(j[e]._config, t)) : (r = Tt(e), r != null && (s = r._config), t = Rt(s, t), r == null && (t.abbr = e), i = new Gt(t), i.parentLocale = j[e], j[e] = i), Te(e);
  } else
    j[e] != null && (j[e].parentLocale != null ? (j[e] = j[e].parentLocale, e === Te() && Te(e)) : j[e] != null && delete j[e]);
  return j[e];
}
function Me(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return tt;
  if (!se(e)) {
    if (t = Tt(e), t)
      return t;
    e = [e];
  }
  return Dl(e);
}
function xl() {
  return Vt(j);
}
function di(e) {
  var t, i = e._a;
  return i && v(e).overflow === -2 && (t = i[pe] < 0 || i[pe] > 11 ? pe : i[le] < 1 || i[le] > ni(i[V], i[pe]) ? le : i[N] < 0 || i[N] > 24 || i[N] === 24 && (i[re] !== 0 || i[be] !== 0 || i[Ae] !== 0) ? N : i[re] < 0 || i[re] > 59 ? re : i[be] < 0 || i[be] > 59 ? be : i[Ae] < 0 || i[Ae] > 999 ? Ae : -1, v(e)._overflowDayOfYear && (t < V || t > le) && (t = le), v(e)._overflowWeeks && t === -1 && (t = Au), v(e)._overflowWeekday && t === -1 && (t = $u), v(e).overflow = t), e;
}
var Tl = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Yl = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Il = /Z|[+-]\d\d(?::?\d\d)?/, dt = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Ut = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Al = /^\/?Date\((-?\d+)/i, $l = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, jl = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function dr(e) {
  var t, i, r = e._i, s = Tl.exec(r) || Yl.exec(r), n, a, u, l, d = dt.length, _ = Ut.length;
  if (s) {
    for (v(e).iso = !0, t = 0, i = d; t < i; t++)
      if (dt[t][1].exec(s[1])) {
        a = dt[t][0], n = dt[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (s[3]) {
      for (t = 0, i = _; t < i; t++)
        if (Ut[t][1].exec(s[3])) {
          u = (s[2] || " ") + Ut[t][0];
          break;
        }
      if (u == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!n && u != null) {
      e._isValid = !1;
      return;
    }
    if (s[4])
      if (Il.exec(s[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (u || "") + (l || ""), ci(e);
  } else
    e._isValid = !1;
}
function El(e, t, i, r, s, n) {
  var a = [
    Pl(e),
    er.indexOf(t),
    parseInt(i, 10),
    parseInt(r, 10),
    parseInt(s, 10)
  ];
  return n && a.push(parseInt(n, 10)), a;
}
function Pl(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Cl(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Ul(e, t, i) {
  if (e) {
    var r = ar.indexOf(e), s = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== s)
      return v(i).weekdayMismatch = !0, i._isValid = !1, !1;
  }
  return !0;
}
function Nl(e, t, i) {
  if (e)
    return jl[e];
  if (t)
    return 0;
  var r = parseInt(i, 10), s = r % 100, n = (r - s) / 100;
  return n * 60 + s;
}
function fr(e) {
  var t = $l.exec(Cl(e._i)), i;
  if (t) {
    if (i = El(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Ul(t[1], i, e))
      return;
    e._a = i, e._tzm = Nl(t[8], t[9], t[10]), e._d = Ge.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), v(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Fl(e) {
  var t = Al.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (dr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (fr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : f.createFromInputFallback(e);
}
f.createFromInputFallback = K(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Ce(e, t, i) {
  return e ?? t ?? i;
}
function Rl(e) {
  var t = new Date(f.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function fi(e) {
  var t, i, r = [], s, n, a;
  if (!e._d) {
    for (s = Rl(e), e._w && e._a[le] == null && e._a[pe] == null && Vl(e), e._dayOfYear != null && (a = Ce(e._a[V], s[V]), (e._dayOfYear > Xe(a) || e._dayOfYear === 0) && (v(e)._overflowDayOfYear = !0), i = Ge(a, 0, e._dayOfYear), e._a[pe] = i.getUTCMonth(), e._a[le] = i.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = s[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[N] === 24 && e._a[re] === 0 && e._a[be] === 0 && e._a[Ae] === 0 && (e._nextDay = !0, e._a[N] = 0), e._d = (e._useUTC ? Ge : Zu).apply(
      null,
      r
    ), n = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[N] = 24), e._w && typeof e._w.d < "u" && e._w.d !== n && (v(e).weekdayMismatch = !0);
  }
}
function Vl(e) {
  var t, i, r, s, n, a, u, l, d;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (n = 1, a = 4, i = Ce(
    t.GG,
    e._a[V],
    et(A(), 1, 4).year
  ), r = Ce(t.W, 1), s = Ce(t.E, 1), (s < 1 || s > 7) && (l = !0)) : (n = e._locale._week.dow, a = e._locale._week.doy, d = et(A(), n, a), i = Ce(t.gg, e._a[V], d.year), r = Ce(t.w, d.week), t.d != null ? (s = t.d, (s < 0 || s > 6) && (l = !0)) : t.e != null ? (s = t.e + n, (t.e < 0 || t.e > 6) && (l = !0)) : s = n), r < 1 || r > ve(i, n, a) ? v(e)._overflowWeeks = !0 : l != null ? v(e)._overflowWeekday = !0 : (u = nr(i, r, s, n, a), e._a[V] = u.year, e._dayOfYear = u.dayOfYear);
}
f.ISO_8601 = function() {
};
f.RFC_2822 = function() {
};
function ci(e) {
  if (e._f === f.ISO_8601) {
    dr(e);
    return;
  }
  if (e._f === f.RFC_2822) {
    fr(e);
    return;
  }
  e._a = [], v(e).empty = !0;
  var t = "" + e._i, i, r, s, n, a, u = t.length, l = 0, d, _;
  for (s = Bi(e._f, e._locale).match(ei) || [], _ = s.length, i = 0; i < _; i++)
    n = s[i], r = (t.match(Tu(n, e)) || [])[0], r && (a = t.substr(0, t.indexOf(r)), a.length > 0 && v(e).unusedInput.push(a), t = t.slice(
      t.indexOf(r) + r.length
    ), l += r.length), Ne[n] ? (r ? v(e).empty = !1 : v(e).unusedTokens.push(n), Iu(n, r, e)) : e._strict && !r && v(e).unusedTokens.push(n);
  v(e).charsLeftOver = u - l, t.length > 0 && v(e).unusedInput.push(t), e._a[N] <= 12 && v(e).bigHour === !0 && e._a[N] > 0 && (v(e).bigHour = void 0), v(e).parsedDateParts = e._a.slice(0), v(e).meridiem = e._meridiem, e._a[N] = Wl(
    e._locale,
    e._a[N],
    e._meridiem
  ), d = v(e).era, d !== null && (e._a[V] = e._locale.erasConvertYear(d, e._a[V])), fi(e), di(e);
}
function Wl(e, t, i) {
  var r;
  return i == null ? t : e.meridiemHour != null ? e.meridiemHour(t, i) : (e.isPM != null && (r = e.isPM(i), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function Ll(e) {
  var t, i, r, s, n, a, u = !1, l = e._f.length;
  if (l === 0) {
    v(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < l; s++)
    n = 0, a = !1, t = Kt({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[s], ci(t), Xt(t) && (a = !0), n += v(t).charsLeftOver, n += v(t).unusedTokens.length * 10, v(t).score = n, u ? n < r && (r = n, i = t) : (r == null || n < r || a) && (r = n, i = t, a && (u = !0));
  qe(e, i || t);
}
function Hl(e) {
  if (!e._d) {
    var t = ti(e._i), i = t.day === void 0 ? t.date : t.day;
    e._a = Li(
      [t.year, t.month, i, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), fi(e);
  }
}
function zl(e) {
  var t = new rt(di(cr(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function cr(e) {
  var t = e._i, i = e._f;
  return e._locale = e._locale || Me(e._l), t === null || i === void 0 && t === "" ? wt({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), ne(t) ? new rt(di(t)) : (it(t) ? e._d = t : se(i) ? Ll(e) : i ? ci(e) : Bl(e), Xt(e) || (e._d = null), e));
}
function Bl(e) {
  var t = e._i;
  z(t) ? e._d = new Date(f.now()) : it(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Fl(e) : se(t) ? (e._a = Li(t.slice(0), function(i) {
    return parseInt(i, 10);
  }), fi(e)) : $e(t) ? Hl(e) : Se(t) ? e._d = new Date(t) : f.createFromInputFallback(e);
}
function hr(e, t, i, r, s) {
  var n = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (i === !0 || i === !1) && (r = i, i = void 0), ($e(e) && Qt(e) || se(e) && e.length === 0) && (e = void 0), n._isAMomentObject = !0, n._useUTC = n._isUTC = s, n._l = i, n._i = e, n._f = t, n._strict = r, zl(n);
}
function A(e, t, i, r) {
  return hr(e, t, i, r, !1);
}
var Zl = K(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = A.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : wt();
  }
), Jl = K(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = A.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : wt();
  }
);
function gr(e, t) {
  var i, r;
  if (t.length === 1 && se(t[0]) && (t = t[0]), !t.length)
    return A();
  for (i = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](i)) && (i = t[r]);
  return i;
}
function Ql() {
  var e = [].slice.call(arguments, 0);
  return gr("isBefore", e);
}
function Xl() {
  var e = [].slice.call(arguments, 0);
  return gr("isAfter", e);
}
var Kl = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Qe = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Gl(e) {
  var t, i = !1, r, s = Qe.length;
  for (t in e)
    if (O(e, t) && !(P.call(Qe, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < s; ++r)
    if (e[Qe[r]]) {
      if (i)
        return !1;
      parseFloat(e[Qe[r]]) !== M(e[Qe[r]]) && (i = !0);
    }
  return !0;
}
function eo() {
  return this._isValid;
}
function to() {
  return ae(NaN);
}
function Yt(e) {
  var t = ti(e), i = t.year || 0, r = t.quarter || 0, s = t.month || 0, n = t.week || t.isoWeek || 0, a = t.day || 0, u = t.hour || 0, l = t.minute || 0, d = t.second || 0, _ = t.millisecond || 0;
  this._isValid = Gl(t), this._milliseconds = +_ + d * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  u * 1e3 * 60 * 60, this._days = +a + n * 7, this._months = +s + r * 3 + i * 12, this._data = {}, this._locale = Me(), this._bubble();
}
function mt(e) {
  return e instanceof Yt;
}
function Lt(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function io(e, t, i) {
  var r = Math.min(e.length, t.length), s = Math.abs(e.length - t.length), n = 0, a;
  for (a = 0; a < r; a++)
    M(e[a]) !== M(t[a]) && n++;
  return n + s;
}
function mr(e, t) {
  y(e, 0, 0, function() {
    var i = this.utcOffset(), r = "+";
    return i < 0 && (i = -i, r = "-"), r + oe(~~(i / 60), 2) + t + oe(~~i % 60, 2);
  });
}
mr("Z", ":");
mr("ZZ", "");
h("Z", qt);
h("ZZ", qt);
x(["Z", "ZZ"], function(e, t, i) {
  i._useUTC = !0, i._tzm = hi(qt, e);
});
var ro = /([\+\-]|\d\d)/gi;
function hi(e, t) {
  var i = (t || "").match(e), r, s, n;
  return i === null ? null : (r = i[i.length - 1] || [], s = (r + "").match(ro) || ["-", 0, 0], n = +(s[1] * 60) + M(s[2]), n === 0 ? 0 : s[0] === "+" ? n : -n);
}
function gi(e, t) {
  var i, r;
  return t._isUTC ? (i = t.clone(), r = (ne(e) || it(e) ? e.valueOf() : A(e).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + r), f.updateOffset(i, !1), i) : A(e).local();
}
function Ht(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
f.updateOffset = function() {
};
function so(e, t, i) {
  var r = this._offset || 0, s;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = hi(qt, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !i && (e = e * 60);
    return !this._isUTC && t && (s = Ht(this)), this._offset = e, this._isUTC = !0, s != null && this.add(s, "m"), r !== e && (!t || this._changeInProgress ? br(
      this,
      ae(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, f.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : Ht(this);
}
function no(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function ao(e) {
  return this.utcOffset(0, e);
}
function uo(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ht(this), "m")), this;
}
function lo() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = hi(qu, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function oo(e) {
  return this.isValid() ? (e = e ? A(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function fo() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function co() {
  if (!z(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Kt(e, this), e = cr(e), e._a ? (t = e._isUTC ? fe(e._a) : A(e._a), this._isDSTShifted = this.isValid() && io(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function ho() {
  return this.isValid() ? !this._isUTC : !1;
}
function go() {
  return this.isValid() ? this._isUTC : !1;
}
function yr() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var mo = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, yo = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function ae(e, t) {
  var i = e, r = null, s, n, a;
  return mt(e) ? i = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Se(e) || !isNaN(+e) ? (i = {}, t ? i[t] = +e : i.milliseconds = +e) : (r = mo.exec(e)) ? (s = r[1] === "-" ? -1 : 1, i = {
    y: 0,
    d: M(r[le]) * s,
    h: M(r[N]) * s,
    m: M(r[re]) * s,
    s: M(r[be]) * s,
    ms: M(Lt(r[Ae] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (r = yo.exec(e)) ? (s = r[1] === "-" ? -1 : 1, i = {
    y: Ie(r[2], s),
    M: Ie(r[3], s),
    w: Ie(r[4], s),
    d: Ie(r[5], s),
    h: Ie(r[6], s),
    m: Ie(r[7], s),
    s: Ie(r[8], s)
  }) : i == null ? i = {} : typeof i == "object" && ("from" in i || "to" in i) && (a = po(
    A(i.from),
    A(i.to)
  ), i = {}, i.ms = a.milliseconds, i.M = a.months), n = new Yt(i), mt(e) && O(e, "_locale") && (n._locale = e._locale), mt(e) && O(e, "_isValid") && (n._isValid = e._isValid), n;
}
ae.fn = Yt.prototype;
ae.invalid = to;
function Ie(e, t) {
  var i = e && parseFloat(e.replace(",", "."));
  return (isNaN(i) ? 0 : i) * t;
}
function xi(e, t) {
  var i = {};
  return i.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(i.months, "M").isAfter(t) && --i.months, i.milliseconds = +t - +e.clone().add(i.months, "M"), i;
}
function po(e, t) {
  var i;
  return e.isValid() && t.isValid() ? (t = gi(t, e), e.isBefore(t) ? i = xi(e, t) : (i = xi(t, e), i.milliseconds = -i.milliseconds, i.months = -i.months), i) : { milliseconds: 0, months: 0 };
}
function pr(e, t) {
  return function(i, r) {
    var s, n;
    return r !== null && !isNaN(+r) && (zi(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), n = i, i = r, r = n), s = ae(i, r), br(this, s, e), this;
  };
}
function br(e, t, i, r) {
  var s = t._milliseconds, n = Lt(t._days), a = Lt(t._months);
  e.isValid() && (r = r ?? !0, a && ir(e, Ke(e, "Month") + a * i), n && Gi(e, "Date", Ke(e, "Date") + n * i), s && e._d.setTime(e._d.valueOf() + s * i), r && f.updateOffset(e, n || a));
}
var bo = pr(1, "add"), _o = pr(-1, "subtract");
function _r(e) {
  return typeof e == "string" || e instanceof String;
}
function vo(e) {
  return ne(e) || it(e) || _r(e) || Se(e) || wo(e) || So(e) || e === null || e === void 0;
}
function So(e) {
  var t = $e(e) && !Qt(e), i = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, n, a = r.length;
  for (s = 0; s < a; s += 1)
    n = r[s], i = i || O(e, n);
  return t && i;
}
function wo(e) {
  var t = se(e), i = !1;
  return t && (i = e.filter(function(r) {
    return !Se(r) && _r(e);
  }).length === 0), t && i;
}
function Mo(e) {
  var t = $e(e) && !Qt(e), i = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, n;
  for (s = 0; s < r.length; s += 1)
    n = r[s], i = i || O(e, n);
  return t && i;
}
function ko(e, t) {
  var i = e.diff(t, "days", !0);
  return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse";
}
function Do(e, t) {
  arguments.length === 1 && (arguments[0] ? vo(arguments[0]) ? (e = arguments[0], t = void 0) : Mo(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var i = e || A(), r = gi(i, this).startOf("day"), s = f.calendarFormat(this, r) || "sameElse", n = t && (ce(t[s]) ? t[s].call(this, i) : t[s]);
  return this.format(
    n || this.localeData().calendar(s, this, A(i))
  );
}
function Oo() {
  return new rt(this);
}
function qo(e, t) {
  var i = ne(e) ? e : A(e);
  return this.isValid() && i.isValid() ? (t = G(t) || "millisecond", t === "millisecond" ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function xo(e, t) {
  var i = ne(e) ? e : A(e);
  return this.isValid() && i.isValid() ? (t = G(t) || "millisecond", t === "millisecond" ? this.valueOf() < i.valueOf() : this.clone().endOf(t).valueOf() < i.valueOf()) : !1;
}
function To(e, t, i, r) {
  var s = ne(e) ? e : A(e), n = ne(t) ? t : A(t);
  return this.isValid() && s.isValid() && n.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(s, i) : !this.isBefore(s, i)) && (r[1] === ")" ? this.isBefore(n, i) : !this.isAfter(n, i))) : !1;
}
function Yo(e, t) {
  var i = ne(e) ? e : A(e), r;
  return this.isValid() && i.isValid() ? (t = G(t) || "millisecond", t === "millisecond" ? this.valueOf() === i.valueOf() : (r = i.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function Io(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Ao(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function $o(e, t, i) {
  var r, s, n;
  if (!this.isValid())
    return NaN;
  if (r = gi(e, this), !r.isValid())
    return NaN;
  switch (s = (r.utcOffset() - this.utcOffset()) * 6e4, t = G(t), t) {
    case "year":
      n = yt(this, r) / 12;
      break;
    case "month":
      n = yt(this, r);
      break;
    case "quarter":
      n = yt(this, r) / 3;
      break;
    case "second":
      n = (this - r) / 1e3;
      break;
    // 1000
    case "minute":
      n = (this - r) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      n = (this - r) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      n = (this - r - s) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      n = (this - r - s) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      n = this - r;
  }
  return i ? n : X(n);
}
function yt(e, t) {
  if (e.date() < t.date())
    return -yt(t, e);
  var i = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(i, "months"), s, n;
  return t - r < 0 ? (s = e.clone().add(i - 1, "months"), n = (t - r) / (r - s)) : (s = e.clone().add(i + 1, "months"), n = (t - r) / (s - r)), -(i + n) || 0;
}
f.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
f.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function jo() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Eo(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, i = t ? this.clone().utc() : this;
  return i.year() < 0 || i.year() > 9999 ? gt(
    i,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ce(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", gt(i, "Z")) : gt(
    i,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Po() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", i, r, s, n;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), i = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", n = t + '[")]', this.format(i + r + s + n);
}
function Co(e) {
  e || (e = this.isUtc() ? f.defaultFormatUtc : f.defaultFormat);
  var t = gt(this, e);
  return this.localeData().postformat(t);
}
function Uo(e, t) {
  return this.isValid() && (ne(e) && e.isValid() || A(e).isValid()) ? ae({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function No(e) {
  return this.from(A(), e);
}
function Fo(e, t) {
  return this.isValid() && (ne(e) && e.isValid() || A(e).isValid()) ? ae({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Ro(e) {
  return this.to(A(), e);
}
function vr(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Me(e), t != null && (this._locale = t), this);
}
var Sr = K(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function wr() {
  return this._locale;
}
var _t = 1e3, Fe = 60 * _t, vt = 60 * Fe, Mr = (365 * 400 + 97) * 24 * vt;
function Re(e, t) {
  return (e % t + t) % t;
}
function kr(e, t, i) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, i) - Mr : new Date(e, t, i).valueOf();
}
function Dr(e, t, i) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, i) - Mr : Date.UTC(e, t, i);
}
function Vo(e) {
  var t, i;
  if (e = G(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? Dr : kr, e) {
    case "year":
      t = i(this.year(), 0, 1);
      break;
    case "quarter":
      t = i(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = i(this.year(), this.month(), 1);
      break;
    case "week":
      t = i(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = i(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Re(
        t + (this._isUTC ? 0 : this.utcOffset() * Fe),
        vt
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Re(t, Fe);
      break;
    case "second":
      t = this._d.valueOf(), t -= Re(t, _t);
      break;
  }
  return this._d.setTime(t), f.updateOffset(this, !0), this;
}
function Wo(e) {
  var t, i;
  if (e = G(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? Dr : kr, e) {
    case "year":
      t = i(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = i(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = i(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = i(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = i(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += vt - Re(
        t + (this._isUTC ? 0 : this.utcOffset() * Fe),
        vt
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Fe - Re(t, Fe) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += _t - Re(t, _t) - 1;
      break;
  }
  return this._d.setTime(t), f.updateOffset(this, !0), this;
}
function Lo() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Ho() {
  return Math.floor(this.valueOf() / 1e3);
}
function zo() {
  return new Date(this.valueOf());
}
function Bo() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Zo() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Jo() {
  return this.isValid() ? this.toISOString() : null;
}
function Qo() {
  return Xt(this);
}
function Xo() {
  return qe({}, v(this));
}
function Ko() {
  return v(this).overflow;
}
function Go() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
y("N", 0, 0, "eraAbbr");
y("NN", 0, 0, "eraAbbr");
y("NNN", 0, 0, "eraAbbr");
y("NNNN", 0, 0, "eraName");
y("NNNNN", 0, 0, "eraNarrow");
y("y", ["y", 1], "yo", "eraYear");
y("y", ["yy", 2], 0, "eraYear");
y("y", ["yyy", 3], 0, "eraYear");
y("y", ["yyyy", 4], 0, "eraYear");
h("N", mi);
h("NN", mi);
h("NNN", mi);
h("NNNN", dd);
h("NNNNN", fd);
x(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, i, r) {
    var s = i._locale.erasParse(e, r, i._strict);
    s ? v(i).era = s : v(i).invalidEra = e;
  }
);
h("y", Ve);
h("yy", Ve);
h("yyy", Ve);
h("yyyy", Ve);
h("yo", cd);
x(["y", "yy", "yyy", "yyyy"], V);
x(["yo"], function(e, t, i, r) {
  var s;
  i._locale._eraYearOrdinalRegex && (s = e.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? t[V] = i._locale.eraYearOrdinalParse(e, s) : t[V] = parseInt(e, 10);
});
function ed(e, t) {
  var i, r, s, n = this._eras || Me("en")._eras;
  for (i = 0, r = n.length; i < r; ++i) {
    switch (typeof n[i].since) {
      case "string":
        s = f(n[i].since).startOf("day"), n[i].since = s.valueOf();
        break;
    }
    switch (typeof n[i].until) {
      case "undefined":
        n[i].until = 1 / 0;
        break;
      case "string":
        s = f(n[i].until).startOf("day").valueOf(), n[i].until = s.valueOf();
        break;
    }
  }
  return n;
}
function td(e, t, i) {
  var r, s, n = this.eras(), a, u, l;
  for (e = e.toUpperCase(), r = 0, s = n.length; r < s; ++r)
    if (a = n[r].name.toUpperCase(), u = n[r].abbr.toUpperCase(), l = n[r].narrow.toUpperCase(), i)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (u === e)
            return n[r];
          break;
        case "NNNN":
          if (a === e)
            return n[r];
          break;
        case "NNNNN":
          if (l === e)
            return n[r];
          break;
      }
    else if ([a, u, l].indexOf(e) >= 0)
      return n[r];
}
function id(e, t) {
  var i = e.since <= e.until ? 1 : -1;
  return t === void 0 ? f(e.since).year() : f(e.since).year() + (t - e.offset) * i;
}
function rd() {
  var e, t, i, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (i = this.clone().startOf("day").valueOf(), r[e].since <= i && i <= r[e].until || r[e].until <= i && i <= r[e].since)
      return r[e].name;
  return "";
}
function sd() {
  var e, t, i, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (i = this.clone().startOf("day").valueOf(), r[e].since <= i && i <= r[e].until || r[e].until <= i && i <= r[e].since)
      return r[e].narrow;
  return "";
}
function nd() {
  var e, t, i, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (i = this.clone().startOf("day").valueOf(), r[e].since <= i && i <= r[e].until || r[e].until <= i && i <= r[e].since)
      return r[e].abbr;
  return "";
}
function ad() {
  var e, t, i, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (i = s[e].since <= s[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return (this.year() - f(s[e].since).year()) * i + s[e].offset;
  return this.year();
}
function ud(e) {
  return O(this, "_erasNameRegex") || yi.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function ld(e) {
  return O(this, "_erasAbbrRegex") || yi.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function od(e) {
  return O(this, "_erasNarrowRegex") || yi.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function mi(e, t) {
  return t.erasAbbrRegex(e);
}
function dd(e, t) {
  return t.erasNameRegex(e);
}
function fd(e, t) {
  return t.erasNarrowRegex(e);
}
function cd(e, t) {
  return t._eraYearOrdinalRegex || Ve;
}
function yi() {
  var e = [], t = [], i = [], r = [], s, n, a, u, l, d = this.eras();
  for (s = 0, n = d.length; s < n; ++s)
    a = _e(d[s].name), u = _e(d[s].abbr), l = _e(d[s].narrow), t.push(a), e.push(u), i.push(l), r.push(a), r.push(u), r.push(l);
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  );
}
y(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
y(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function It(e, t) {
  y(0, [e, e.length], 0, t);
}
It("gggg", "weekYear");
It("ggggg", "weekYear");
It("GGGG", "isoWeekYear");
It("GGGGG", "isoWeekYear");
h("G", Ot);
h("g", Ot);
h("GG", $, Q);
h("gg", $, Q);
h("GGGG", ri, ii);
h("gggg", ri, ii);
h("GGGGG", Dt, Mt);
h("ggggg", Dt, Mt);
nt(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, i, r) {
    t[r.substr(0, 2)] = M(e);
  }
);
nt(["gg", "GG"], function(e, t, i, r) {
  t[r] = f.parseTwoDigitYear(e);
});
function hd(e) {
  return Or.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function gd(e) {
  return Or.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function md() {
  return ve(this.year(), 1, 4);
}
function yd() {
  return ve(this.isoWeekYear(), 1, 4);
}
function pd() {
  var e = this.localeData()._week;
  return ve(this.year(), e.dow, e.doy);
}
function bd() {
  var e = this.localeData()._week;
  return ve(this.weekYear(), e.dow, e.doy);
}
function Or(e, t, i, r, s) {
  var n;
  return e == null ? et(this, r, s).year : (n = ve(e, r, s), t > n && (t = n), _d.call(this, e, t, i, r, s));
}
function _d(e, t, i, r, s) {
  var n = nr(e, t, i, r, s), a = Ge(n.year, 0, n.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
y("Q", 0, "Qo", "quarter");
h("Q", Zi);
x("Q", function(e, t) {
  t[pe] = (M(e) - 1) * 3;
});
function vd(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
y("D", ["DD", 2], "Do", "date");
h("D", $, We);
h("DD", $, Q);
h("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
x(["D", "DD"], le);
x("Do", function(e, t) {
  t[le] = M(e.match($)[0]);
});
var qr = Le("Date", !0);
y("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
h("DDD", kt);
h("DDDD", Ji);
x(["DDD", "DDDD"], function(e, t, i) {
  i._dayOfYear = M(e);
});
function Sd(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
y("m", ["mm", 2], 0, "minute");
h("m", $, si);
h("mm", $, Q);
x(["m", "mm"], re);
var wd = Le("Minutes", !1);
y("s", ["ss", 2], 0, "second");
h("s", $, si);
h("ss", $, Q);
x(["s", "ss"], be);
var Md = Le("Seconds", !1);
y("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
y(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
y(0, ["SSS", 3], 0, "millisecond");
y(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
y(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
y(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
y(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
y(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
y(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
h("S", kt, Zi);
h("SS", kt, Q);
h("SSS", kt, Ji);
var xe, xr;
for (xe = "SSSS"; xe.length <= 9; xe += "S")
  h(xe, Ve);
function kd(e, t) {
  t[Ae] = M(("0." + e) * 1e3);
}
for (xe = "S"; xe.length <= 9; xe += "S")
  x(xe, kd);
xr = Le("Milliseconds", !1);
y("z", 0, 0, "zoneAbbr");
y("zz", 0, 0, "zoneName");
function Dd() {
  return this._isUTC ? "UTC" : "";
}
function Od() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var o = rt.prototype;
o.add = bo;
o.calendar = Do;
o.clone = Oo;
o.diff = $o;
o.endOf = Wo;
o.format = Co;
o.from = Uo;
o.fromNow = No;
o.to = Fo;
o.toNow = Ro;
o.get = Eu;
o.invalidAt = Ko;
o.isAfter = qo;
o.isBefore = xo;
o.isBetween = To;
o.isSame = Yo;
o.isSameOrAfter = Io;
o.isSameOrBefore = Ao;
o.isValid = Qo;
o.lang = Sr;
o.locale = vr;
o.localeData = wr;
o.max = Jl;
o.min = Zl;
o.parsingFlags = Xo;
o.set = Pu;
o.startOf = Vo;
o.subtract = _o;
o.toArray = Bo;
o.toObject = Zo;
o.toDate = zo;
o.toISOString = Eo;
o.inspect = Po;
typeof Symbol < "u" && Symbol.for != null && (o[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
o.toJSON = Jo;
o.toString = jo;
o.unix = Ho;
o.valueOf = Lo;
o.creationData = Go;
o.eraName = rd;
o.eraNarrow = sd;
o.eraAbbr = nd;
o.eraYear = ad;
o.year = Ki;
o.isLeapYear = ju;
o.weekYear = hd;
o.isoWeekYear = gd;
o.quarter = o.quarters = vd;
o.month = rr;
o.daysInMonth = Hu;
o.week = o.weeks = Gu;
o.isoWeek = o.isoWeeks = el;
o.weeksInYear = pd;
o.weeksInWeekYear = bd;
o.isoWeeksInYear = md;
o.isoWeeksInISOWeekYear = yd;
o.date = qr;
o.day = o.days = hl;
o.weekday = gl;
o.isoWeekday = ml;
o.dayOfYear = Sd;
o.hour = o.hours = wl;
o.minute = o.minutes = wd;
o.second = o.seconds = Md;
o.millisecond = o.milliseconds = xr;
o.utcOffset = so;
o.utc = ao;
o.local = uo;
o.parseZone = lo;
o.hasAlignedHourOffset = oo;
o.isDST = fo;
o.isLocal = ho;
o.isUtcOffset = go;
o.isUtc = yr;
o.isUTC = yr;
o.zoneAbbr = Dd;
o.zoneName = Od;
o.dates = K(
  "dates accessor is deprecated. Use date instead.",
  qr
);
o.months = K(
  "months accessor is deprecated. Use month instead",
  rr
);
o.years = K(
  "years accessor is deprecated. Use year instead",
  Ki
);
o.zone = K(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  no
);
o.isDSTShifted = K(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  co
);
function qd(e) {
  return A(e * 1e3);
}
function xd() {
  return A.apply(null, arguments).parseZone();
}
function Tr(e) {
  return e;
}
var q = Gt.prototype;
q.calendar = cu;
q.longDateFormat = yu;
q.invalidDate = bu;
q.ordinal = Su;
q.preparse = Tr;
q.postformat = Tr;
q.relativeTime = Mu;
q.pastFuture = ku;
q.set = du;
q.eras = ed;
q.erasParse = td;
q.erasConvertYear = id;
q.erasAbbrRegex = ld;
q.erasNameRegex = ud;
q.erasNarrowRegex = od;
q.months = Ru;
q.monthsShort = Vu;
q.monthsParse = Lu;
q.monthsRegex = Bu;
q.monthsShortRegex = zu;
q.week = Ju;
q.firstDayOfYear = Ku;
q.firstDayOfWeek = Xu;
q.weekdays = ll;
q.weekdaysMin = dl;
q.weekdaysShort = ol;
q.weekdaysParse = cl;
q.weekdaysRegex = yl;
q.weekdaysShortRegex = pl;
q.weekdaysMinRegex = bl;
q.isPM = vl;
q.meridiem = Ml;
function St(e, t, i, r) {
  var s = Me(), n = fe().set(r, t);
  return s[i](n, e);
}
function Yr(e, t, i) {
  if (Se(e) && (t = e, e = void 0), e = e || "", t != null)
    return St(e, t, i, "month");
  var r, s = [];
  for (r = 0; r < 12; r++)
    s[r] = St(e, r, i, "month");
  return s;
}
function pi(e, t, i, r) {
  typeof e == "boolean" ? (Se(t) && (i = t, t = void 0), t = t || "") : (t = e, i = t, e = !1, Se(t) && (i = t, t = void 0), t = t || "");
  var s = Me(), n = e ? s._week.dow : 0, a, u = [];
  if (i != null)
    return St(t, (i + n) % 7, r, "day");
  for (a = 0; a < 7; a++)
    u[a] = St(t, (a + n) % 7, r, "day");
  return u;
}
function Td(e, t) {
  return Yr(e, t, "months");
}
function Yd(e, t) {
  return Yr(e, t, "monthsShort");
}
function Id(e, t, i) {
  return pi(e, t, i, "weekdays");
}
function Ad(e, t, i) {
  return pi(e, t, i, "weekdaysShort");
}
function $d(e, t, i) {
  return pi(e, t, i, "weekdaysMin");
}
Te("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, i = M(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + i;
  }
});
f.lang = K(
  "moment.lang is deprecated. Use moment.locale instead.",
  Te
);
f.langData = K(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Me
);
var me = Math.abs;
function jd() {
  var e = this._data;
  return this._milliseconds = me(this._milliseconds), this._days = me(this._days), this._months = me(this._months), e.milliseconds = me(e.milliseconds), e.seconds = me(e.seconds), e.minutes = me(e.minutes), e.hours = me(e.hours), e.months = me(e.months), e.years = me(e.years), this;
}
function Ir(e, t, i, r) {
  var s = ae(t, i);
  return e._milliseconds += r * s._milliseconds, e._days += r * s._days, e._months += r * s._months, e._bubble();
}
function Ed(e, t) {
  return Ir(this, e, t, 1);
}
function Pd(e, t) {
  return Ir(this, e, t, -1);
}
function Ti(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Cd() {
  var e = this._milliseconds, t = this._days, i = this._months, r = this._data, s, n, a, u, l;
  return e >= 0 && t >= 0 && i >= 0 || e <= 0 && t <= 0 && i <= 0 || (e += Ti(zt(i) + t) * 864e5, t = 0, i = 0), r.milliseconds = e % 1e3, s = X(e / 1e3), r.seconds = s % 60, n = X(s / 60), r.minutes = n % 60, a = X(n / 60), r.hours = a % 24, t += X(a / 24), l = X(Ar(t)), i += l, t -= Ti(zt(l)), u = X(i / 12), i %= 12, r.days = t, r.months = i, r.years = u, this;
}
function Ar(e) {
  return e * 4800 / 146097;
}
function zt(e) {
  return e * 146097 / 4800;
}
function Ud(e) {
  if (!this.isValid())
    return NaN;
  var t, i, r = this._milliseconds;
  if (e = G(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, i = this._months + Ar(t), e) {
      case "month":
        return i;
      case "quarter":
        return i / 3;
      case "year":
        return i / 12;
    }
  else
    switch (t = this._days + Math.round(zt(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function ke(e) {
  return function() {
    return this.as(e);
  };
}
var $r = ke("ms"), Nd = ke("s"), Fd = ke("m"), Rd = ke("h"), Vd = ke("d"), Wd = ke("w"), Ld = ke("M"), Hd = ke("Q"), zd = ke("y"), Bd = $r;
function Zd() {
  return ae(this);
}
function Jd(e) {
  return e = G(e), this.isValid() ? this[e + "s"]() : NaN;
}
function je(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Qd = je("milliseconds"), Xd = je("seconds"), Kd = je("minutes"), Gd = je("hours"), ef = je("days"), tf = je("months"), rf = je("years");
function sf() {
  return X(this.days() / 7);
}
var ye = Math.round, Ue = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function nf(e, t, i, r, s) {
  return s.relativeTime(t || 1, !!i, e, r);
}
function af(e, t, i, r) {
  var s = ae(e).abs(), n = ye(s.as("s")), a = ye(s.as("m")), u = ye(s.as("h")), l = ye(s.as("d")), d = ye(s.as("M")), _ = ye(s.as("w")), w = ye(s.as("y")), T = n <= i.ss && ["s", n] || n < i.s && ["ss", n] || a <= 1 && ["m"] || a < i.m && ["mm", a] || u <= 1 && ["h"] || u < i.h && ["hh", u] || l <= 1 && ["d"] || l < i.d && ["dd", l];
  return i.w != null && (T = T || _ <= 1 && ["w"] || _ < i.w && ["ww", _]), T = T || d <= 1 && ["M"] || d < i.M && ["MM", d] || w <= 1 && ["y"] || ["yy", w], T[2] = t, T[3] = +e > 0, T[4] = r, nf.apply(null, T);
}
function uf(e) {
  return e === void 0 ? ye : typeof e == "function" ? (ye = e, !0) : !1;
}
function lf(e, t) {
  return Ue[e] === void 0 ? !1 : t === void 0 ? Ue[e] : (Ue[e] = t, e === "s" && (Ue.ss = t - 1), !0);
}
function of(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var i = !1, r = Ue, s, n;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (i = e), typeof t == "object" && (r = Object.assign({}, Ue, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), s = this.localeData(), n = af(this, !i, r, s), i && (n = s.pastFuture(+this, n)), s.postformat(n);
}
var Nt = Math.abs;
function Pe(e) {
  return (e > 0) - (e < 0) || +e;
}
function At() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Nt(this._milliseconds) / 1e3, t = Nt(this._days), i = Nt(this._months), r, s, n, a, u = this.asSeconds(), l, d, _, w;
  return u ? (r = X(e / 60), s = X(r / 60), e %= 60, r %= 60, n = X(i / 12), i %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = u < 0 ? "-" : "", d = Pe(this._months) !== Pe(u) ? "-" : "", _ = Pe(this._days) !== Pe(u) ? "-" : "", w = Pe(this._milliseconds) !== Pe(u) ? "-" : "", l + "P" + (n ? d + n + "Y" : "") + (i ? d + i + "M" : "") + (t ? _ + t + "D" : "") + (s || r || e ? "T" : "") + (s ? w + s + "H" : "") + (r ? w + r + "M" : "") + (e ? w + a + "S" : "")) : "P0D";
}
var D = Yt.prototype;
D.isValid = eo;
D.abs = jd;
D.add = Ed;
D.subtract = Pd;
D.as = Ud;
D.asMilliseconds = $r;
D.asSeconds = Nd;
D.asMinutes = Fd;
D.asHours = Rd;
D.asDays = Vd;
D.asWeeks = Wd;
D.asMonths = Ld;
D.asQuarters = Hd;
D.asYears = zd;
D.valueOf = Bd;
D._bubble = Cd;
D.clone = Zd;
D.get = Jd;
D.milliseconds = Qd;
D.seconds = Xd;
D.minutes = Kd;
D.hours = Gd;
D.days = ef;
D.weeks = sf;
D.months = tf;
D.years = rf;
D.humanize = of;
D.toISOString = At;
D.toString = At;
D.toJSON = At;
D.locale = vr;
D.localeData = wr;
D.toIsoString = K(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  At
);
D.lang = Sr;
y("X", 0, 0, "unix");
y("x", 0, 0, "valueOf");
h("x", Ot);
h("X", xu);
x("X", function(e, t, i) {
  i._d = new Date(parseFloat(e) * 1e3);
});
x("x", function(e, t, i) {
  i._d = new Date(M(e));
});
//! moment.js
f.version = "2.30.1";
lu(A);
f.fn = o;
f.min = Ql;
f.max = Xl;
f.now = Kl;
f.utc = fe;
f.unix = qd;
f.months = Td;
f.isDate = it;
f.locale = Te;
f.invalid = wt;
f.duration = ae;
f.isMoment = ne;
f.weekdays = Id;
f.parseZone = xd;
f.localeData = Me;
f.isDuration = mt;
f.monthsShort = Yd;
f.weekdaysMin = $d;
f.defineLocale = oi;
f.updateLocale = ql;
f.locales = xl;
f.weekdaysShort = Ad;
f.normalizeUnits = G;
f.relativeTimeRounding = uf;
f.relativeTimeThreshold = lf;
f.calendarFormat = ko;
f.prototype = o;
f.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function gf(e) {
  const t = e.creators.filter((ue) => ue.name).map((ue) => ue.user ? Yi(ue.user.name) : Yi(ue.name));
  let i;
  t.length === 0 ? i = "" : t.length === 1 ? i = t[0] : t.length > 20 ? i = t.slice(0, 19).join(", ") + ", . . . " + t[t.length - 1] : i = t.slice(0, t.length - 1).join(", ") + ", & " + t[t.length - 1];
  const r = df(e.dateIssued, e.language, e.citationConferenceDateStart, e.citationConferenceDateEnd);
  let s = "";
  e.citationEdition && e.citationEdition > 1 && (e.language === "por" ? s = `${e.citationEdition}ª ed.` : e.citationEdition === 2 ? s = `${e.citationEdition}nd ed.` : e.citationEdition === 3 ? s = `${e.citationEdition}rd ed.` : s = `${e.citationEdition}th ed.`);
  const n = e.citationVolume || "";
  let a = "";
  e.citationStartPage && e.citationEndPage && (a = `${e.citationStartPage}-${e.citationEndPage}`);
  let u = "";
  e.citationIssue && (u = `(${e.citationIssue})`);
  const l = e.type === "journal-article";
  let d = "";
  !l && (s || n || a) && (d += " (", s && (d += s, (n || a) && (d += ", ")), n && (d += "Vol. " + n, a && (d += ", ")), a && (d += "pp. " + a), d += ").");
  let _ = "";
  l && (n || u || a) && (_ += " ", n && (_ += n, (u || a) && (_ += " ")), u && (_ += u, a && (_ += " ")), a && (_ += a), _ += ".");
  let w = "";
  (e.institutionName || e.publisher) && (w = " " + (e.institutionName || e.publisher) + (l ? "," : "."));
  let T = "";
  e.doi && (T = " https://doi.org/" + e.doi);
  let U = e.title;
  e.citationTitle && (U += ". " + e.citationTitle);
  let ee = "";
  return e.citationConferencePlace && (ee = " " + e.citationConferencePlace + "."), `${i} (${r}). ${U}.${d}${w}${_}${ee}${T}`;
}
function Yi(e) {
  if (e.includes(",") || e.includes("."))
    return e;
  const t = e.trim().split(" "), i = t.pop();
  if (i.length === 1) return e;
  const r = t.map((n) => `${n.charAt(0)}.`).join(" ");
  return `${i}, ${r}`;
}
function df(e, t, i, r) {
  if (i && r && i.month === r.month) {
    const s = ff(i);
    return t === "por" ? t = "pt" : t = "en", `${s.locale(t).format("YYYY, MMMM D")}-${r.day}`;
  }
  return (e == null ? void 0 : e.year) ?? "n.d.";
}
const ff = (e) => {
  if (e == null)
    return e;
  const t = [];
  return e.year !== void 0 && t.push(e.year), e.month !== void 0 && t.push(e.month - 1), e.day !== void 0 && t.push(e.day), f(t);
}, mf = ["creators", "advisors", "editors"];
class yf {
  constructor({ validator: t, bestValues: i, calculatedValues: r } = {}) {
    t && this.overwriteValidators(t), i && this.overwriteBestValues(i), r && this.overwriteCalculatedValues(r), this.parsers = {
      "master-thesis": Cr(H, Z, J),
      "doctoral-thesis": Ur(H, Z, J),
      "journal-article": Nr(H, Z, J),
      book: Fr(H, Z, J),
      "book-part": Rr(H, Z, J),
      "conference-object": Vr(H, Z, J),
      other: Wr(H, Z, J),
      report: Lr(H, Z, J),
      lecture: zr(H, Z, J),
      patent: Hr(H, Z, J)
    }, this.validators = H;
  }
  /**
   * Verifies if a version corresponds to a reviewed publication
   * @param {string} version Version of record
   * @returns A boolean with the result
   */
  static peerReviewed(t) {
    return $i.includes(t) ? !0 : ji.includes(t) ? !1 : null;
  }
  /**
   * Allows the use of any validator present in the validators (this function can throw errors)
   * @param {string} validator String with validator name for the field
   * @param {object} field Field value to validate
   * @returns Object with the result of the validation
   */
  async validateField(t, i) {
    if (t in this.validators)
      return this.validators[t](i);
    throw Error(`Validator "${t}" wasn't found in validators`);
  }
  /**
   * Returns all available parsers.
   * @returns Returns all available parsers
   */
  getAllParsers() {
    return this.parsers;
  }
  /**
   * Get the parser for a specific type of publication
   * @param {string} type Type of publication for witch you want a parser
   * @returns {import('./parsers/Parser').default} Returns the parser asked by
   */
  getParserByType(t) {
    const i = this.parsers[t];
    if (!i)
      throw Error(`The type "${t}" is not available as a parser`);
    return i;
  }
  /**
   * Get the specific type of a record
   * @param {object} record Record
   * @returns {string} Returns the record type
   */
  getType(t) {
    return t.type;
  }
  /**
   * Get the specific unique type of a record
   * @param {object} record Record
   * @returns {Promise<string>} Returns the record unique type
   */
  async getUniqueType(t) {
    return this.parsers[this.getType(t)].getUniqueType(t);
  }
  /**
   * Format record according to type
   * @param {string} type Type of format you want to format the record (ex: bibtex)
   * @param {object} record Record
   * @returns {string} Returns the record formatted has the type
   */
  formatTo(t, i) {
    let r;
    switch (t) {
      case "bibtex":
        r = new ru(this, i);
        break;
      default:
        throw new Error(`No formatter for type ${t}`);
    }
    return r.output();
  }
  /**
   * Check if a record has a nullish unique type
   * @param {object} record Record
   * @returns {Promise<boolean>} boolean value indicating whether the unique type of the record is nullish
   */
  async hasNullishUniqueType(t) {
    return this.parsers[t.type].hasNullishUniqueType(t);
  }
  /**
   * A function that returns the files available
   * @param {object} record A record of the scholar system
   * @param {boolean} isAuthenticated True if the requester is authenticated
   * @returns {object[]} Returns the files that are available
   */
  filesAvailable(t, i) {
    return t.files.map((r) => {
      switch (r.rights ?? t.rights) {
        case "embargoed-access":
          return !t.dateAvailable || Ze(this.dateObjectAsDate(t.dateAvailable)).isBefore(Ze()) ? r : { ...r, id: void 0 };
        case "restricted-access":
          return i ? r : { ...r, id: void 0 };
        case "metadata-only-access":
          return { ...r, id: void 0 };
        default:
          return r;
      }
    });
  }
  dateObjectAsDate({ year: t, month: i, day: r }) {
    if (!t)
      throw Error("Invalid record a date object must have a year");
    let s = String(t);
    return i ? (s += `-${i}`, r ? (s += `-${r}`, Ze(s, "YYYY-MM-DD").toDate()) : Ze(s, "YYYY-MM").toDate()) : Ze(s, "YYYY").toDate();
  }
  overwriteValidators(t) {
    for (const i in t) {
      if (!H[i])
        throw new Error("Can't override validator key that doesn't exist");
      H[i] = t[i](H[i]);
    }
  }
  overwriteBestValues(t) {
    for (const i in t) {
      if (!Z[i])
        throw new Error("Can't override best value key that doesn't exist");
      Z[i] = t[i](Z[i]);
    }
  }
  overwriteCalculatedValues(t) {
    for (const i in t) {
      if (!J[i])
        throw new Error("Can't override best value key that doesn't exist");
      J[i] = t[i](J[i]);
    }
  }
}
export {
  yf as MetadataUtils,
  we as fieldValues,
  gf as formatAPA,
  Ei as language,
  es as rights,
  mf as signatureFields,
  Ai as subjectFos,
  Qr as subjectFosTranslations,
  Jr as types,
  hf as typesFormatters
};
//# sourceMappingURL=metadata-utils3.js.map
